/**
 * クラス名：板金子部品見積
 * 説明：板金子部品のタブ纏めJSファイルである。
 * 作成者：ナンス
 * 作成日：2023/03/01
 * バージョン：1.0
 */
import React, { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import {
  Table,
  Form,
  Button,
  Row,
  Col,
  Space,
  Image,
  Tooltip,
  Modal,
  Checkbox,
  Spin,
  Input,
  Typography,
  Select,
} from 'antd';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import {
  CloseOutlined,
  CaretRightOutlined,
  FileExclamationOutlined,
  FileDoneOutlined,
  FileAddOutlined,
  FormOutlined,
  DollarOutlined,
  MoneyCollectOutlined,
  ShopOutlined,
  ShoppingOutlined,
  ProductOutlined,
  PayCircleOutlined,
  CaretUpFilled,
  CaretDownFilled,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

import '../../assets/styles/common.css';
import '../../assets/styles/style.css';
import down_Arrow from '../../assets/images/down_Arrow.png';
import up_Arrow from '../../assets/images/up_Arrow.png';
import child_add from '../../assets/images/child_add.png';
import child_delete from '../../assets/images/child_delete.png';
import IQ3EstimateDetail from './IQ3EstimateDetail';
import KouteiSuryouBetsuBtn from '../parent/KouteiSuryouBetsuBtn';
import IQ3Purchase from './IQ3Purchase';
import IQ3KouteiCalculate from '../iq3/IQ3KouteiCalculate';
import IQ3KouteiInput from '../iq3/IQ3KouteiInput';
import IQ3KouteiSentaku from '../iq3/IQ3KouteiSentaku';
import IQ3MaterialDetail from './IQ3MaterialDetail';
import {
  commonTaiochuModal,
  confirmUpdateContent,
  confirmDiscardContent,
  confirmScreenChangeContent,
  confirmScreenChangeTitle,
  confirmModalTitle,
  commonModal,
  commonFooter,
  commonDeleteFooter,
  commonResponsiveConfirmModal,
  requestRecordNumModalTitle,
  CommonResponsiveModal,
  confirmPMXSaveContent,
  confirmCalSimCadContent,
} from '../common/CommonModal';
import parent_call_detail from '../../assets/images/parent_call_detail.png';
import ParentList from '../parent/ParentList';
import EstimateFormulaModal from '../common/EstimateFormulaModal.js';
import {
  getMaterialNameById,
  getMaterialTypeById,
  getMaterialSurfaceById,
  getMaterialThickById,
  iq3EstimateInitInfo,
  padWithLeadingZeros,
  formatDateString,
  todayTime,
  toDecimal,
  updateEstimateInfoByReCal,
  JPYs,
  getDetails,
  getInitMaterialSizeInfo,
  getInitMaterialPatternsInfo,
  reCalMaterial,
  getMaterialAutoSize,
  getDisplayMaterialSizeIq3,
  blobToBase64,
  getAccessToken,
  getCommonProcessMstData,
} from '../common/Common.js';
import {
  GetParametersByCompId,
  getEstimateIq3Info,
  getExistCompanySetting,
  getImageURL,
  updateUserSetting,
} from '../common/CommonAPI.js';
import {
  WorkType,
  DataType,
  ServiceClass,
  SurfaceProtectionType,
  EstimateCreationType,
  WorkTypeGroup,
  UserRoleToString,
} from '../common/enums.js';
import {
  amtEmptyStr,
  BendingTypes,
  BlankTypes,
  FRBend,
  IQxRealGoku_AudiToken,
  SecondaryWorkTypes,
  SM_CAD_ExternalAppID,
  SM_CAD_FeatureID,
  SubWeldTypes,
  Types,
} from '../common/Constant';
import copy_sm from '../../assets/images/copy_sm.png';
import edit_list from '../../assets/images/edit_list.png';
import manual from '../../assets/images/manual.png';
import auto from '../../assets/images/auto.png';
import Draggable from 'react-draggable';
import axios from 'axios';
import { AppUserContext } from './AppUserContext';

dayjs.extend(customParseFormat);

const IQ3Estimate = forwardRef((props, ref) => {
  const navigate = useNavigate();
  const [selectedData, setSelectedData] = React.useState();
  const [modalTitleTxt, setMdalTitleTxt] = useState('確認');
  // 確認ダイアログ
  const [confirmMsgOpen, setConfirmMsgOpen] = useState(false);
  const [editMode, setEditMode] = useState(true);
  const [discardMode, setDiscardMode] = useState(false);
  const [iQ3DataLst, setIQ3DataLst] = useState([]);
  const [selectedEstimateData, setSelectedEstimateData] = useState([]);
  const [editModeCancelConfirm, setEditModeCancelConfirm] = useState(false);
  const [currentRecordNo, setCurrentRecordNo] = useState(0);
  // 開発中ポップアップ
  const [openCommonTaiochuPopup, setOpenCommonTaiochuPopup] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState('0');
  const [selectedTabKey, setSelectedTabKey] = useState('1');
  const [isDialogOk, setIsDialogOk] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [parentListDisplay, setParentListDisplay] = useState(false);
  const [selectedParentAddEstimate, setSelectedParentAddEstimate] = useState([]);
  const [isAddPart, setIsAddPart] = useState(false);
  const [materialLst, setMaterialLst] = useState([]);
  const [isSetting, setIsSetting] = useState(false);
  const [deviceMasterInfo, setDeviceMasterInfo] = useState([]);
  const [processMasterInfo, setProcessMasterInfo] = useState([]);
  const [clientMasterInfo, setClientMasterInfo] = useState([]);
  const [newParameters, setNewParameters] = useState();
  // Waitingダイアログの表示
  const [iq3Loading, setIq3Loading] = useState(true);
  // 材料詳細のタグを最初として入るかの判断
  const [isFirstTimeMaterialDetail, setIsFirstTimeMaterialDetail] = useState(true);
  const [iq3ActionForCal, setIq3ActionForCal] = useState(false);
  const [selectedProcessSelect, setSelectedProcessSelect] = useState({});
  const [iq3PMXDatas, setIq3PMXDatas] = useState([]);
  const [currentRecordNoPMX, setCurrentRecordNoPMX] = useState(0);
  const [detailTabModalWidth, setDetailTabModalWidth] = useState(1200);
  const [reCalByAddDelete, setReCalByAddDelete] = useState(false);
  const [isPartCountChange, setIsPartCountChange] = useState(false);
  const [currentRecordNoByChangeQty, setCurrentRecordNoByChangeQty] = useState(1);
  const [currentRecordNoByBultEdit, setCurrentRecordNoByBultEdit] = useState(0);
  const [isBulkEditAction, setIsBulkEditAction] = useState(false);
  const [hasProcessInputChanged, setHasProcessInputChanged] = useState(false);

  //
  const [tempProcessSelect, setTempProcessSelect] = useState(null);

  const [isGetFileImg, setIsGetFileImg] = useState(false);

  // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
  const [recordNum, setRecordNum] = useState(1);
  const [visibleRecordNum, setVisibleRecordNum] = useState(false);
  const [recordAddOrCopy, setRecordAddOrCopy] = useState('1');
  const [inputValue, setInputValue] = useState('');
  const [showSMCadComponent, setShowSMCadComponent] = useState(false);
  const [curPMXInfo, setCurPmxInfo] = useState('');
  const [confirmCalCadSim, setConfirmCalCadSim] = useState(false);
  const [simCadParamCompanyID, setSimCadParamCompanyID] = useState('zf');
  const [simCadParamUserId, setSimCadParamUserId] = useState('team-dev');

  // 板金子部品プロパティ情報
  let iq3DetailRef = useRef();

  // 工程選択
  let iq3KouteiSentakuRef = useRef();

  // 工程計算
  let iq3KouteiCalRef = useRef();

  // 工程入力
  let iq3KouteiInputRef = useRef();

  // 購入品
  let purchaseRef = useRef();

  // 材料詳細
  let iq3MaterialDetailRef = useRef();

  const estimateParameters = props.selectedEstimateData?.estimateProducts?.calcParameters?.parameters;

  // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
  let materialLstSelect = estimateParameters?.materialIq3?.filter((i) => i?.info?.isUsed);
  // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
  // 材質名称リスト
  let materialTypeLstSelect = estimateParameters?.materialTypeIq3?.filter((i) => i?.info?.isUsed);
  materialTypeLstSelect = estimateParameters?.materialTypeIq3?.sort((a, b) => a?.info?.sortNum - b?.info?.sortNum);
  // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
  let materialSurfaceLstSelect = estimateParameters?.materialSurfaceIq3?.filter((i) => i?.info?.isUsed);

  // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
  // 変更した材質名称によって表示する材料サイズマスタ情報を得る
  const getFilteredMaterialSizeIq3 = (materialTypeIq3Id) => {
    let parameters = props.selectedEstimateData?.estimateProducts?.calcParameters?.parameters;
    let materialSizeIq3Infos = parameters?.materialSizeIq3;
    let filteredMaterialSizeIq3 = getDisplayMaterialSizeIq3(materialTypeIq3Id, materialSizeIq3Infos);
    return filteredMaterialSizeIq3;
  };

  // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
  // 変更した材質名称によって表示する材料サイズリストを得る
  const getMSizeListByMTypeIq3Id = (materialTypeIq3Id) => {
    let materialDetailSizes = [];
    let filteredMaterialSizeIq3 = getFilteredMaterialSizeIq3(materialTypeIq3Id);
    materialDetailSizes = filteredMaterialSizeIq3?.map((item, index) => {
      if (item?.sizeName === 'Other') {
        item = { ...item, isUsed: true };
      }
      return getInitMaterialSizeInfo(index, item);
    });
    return materialDetailSizes;
  };

  // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
  // 変更した材質名称によって表示する材料パターンリストを得る
  const getMPatternListByMTypeIq3Id = (materialTypeIq3Id, detailData) => {
    let materialDetailPatterns = [];
    let filteredMaterialSizeIq3 = getFilteredMaterialSizeIq3(materialTypeIq3Id);
    filteredMaterialSizeIq3?.map((item, index) => {
      let copyItem = JSON.parse(JSON.stringify(item));
      if (item?.sizeName === 'Other') {
        let iq3Info = detailData;
        // 材料サイズX計算
        let sheetX = getMaterialAutoSize(iq3Info, false);
        // 材料サイズY計算
        let sheetY = getMaterialAutoSize(iq3Info, false, false);
        copyItem = { ...copyItem, info: { ...copyItem.info, sizeX: sheetX, sizeY: sheetY } };
      }
      materialDetailPatterns = getInitMaterialPatternsInfo(materialDetailPatterns, copyItem);
    });
    return materialDetailPatterns;
  };

  // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
  // 材質を変更した時、材料、板厚、表面保護の情報をフィルターする
  const filteredInfoByMaterialType = async (materialTypeId, materialId, index) => {
    let tempIQ3List = [...iQ3DataLst];
    let materialSurfaceId = 0;

    tempIQ3List[index].thickness = materialId;
    tempIQ3List[index].materialIq3Id = materialId;
    tempIQ3List[index].materialName = getMaterialNameById(materialId, materialLst);

    // 材料表面情報
    let materialSurfaceList = materialSurfaceLstSelect?.filter(
      (item) => item.info.isUsed && item.materialTypeIq3Id === materialTypeId
    );
    if (materialSurfaceList?.length > 0) {
      materialSurfaceId = materialSurfaceList[0]?.id;
    }

    tempIQ3List[index].materialSurfaceIq3Id = materialSurfaceId;
    tempIQ3List[index].materialSurfaceName = getMaterialSurfaceById(materialSurfaceId, materialSurfaceLstSelect);
    tempIQ3List[index].materialDetailSizes = getMSizeListByMTypeIq3Id(materialTypeId);
    tempIQ3List[index].materialDetailPatterns = getMPatternListByMTypeIq3Id(materialTypeId, tempIQ3List[index]);

    setIQ3DataLst(tempIQ3List);

    props.selectedEstimateData.esIq3Info[index].thickness = materialId;
    props.selectedEstimateData.esIq3Info[index].materialIq3Id = materialId;
    props.selectedEstimateData.esIq3Info[index].materialName = tempIQ3List[index].materialName;
    props.selectedEstimateData.esIq3Info[index].materialSurfaceIq3Id = materialSurfaceId;
    props.selectedEstimateData.esIq3Info[index].materialSurfaceName = tempIQ3List[index].materialSurfaceName;
    props.selectedEstimateData.esIq3Info[index].materialDetailSizes = tempIQ3List[index].materialDetailSizes;
    props.selectedEstimateData.esIq3Info[index].materialDetailPatterns = tempIQ3List[index].materialDetailPatterns;
    let userSetting = props.selectedEstimateData.estimateProducts.calcParameters.settings.userSettings;
    if (userSetting?.length > 0) userSetting = userSetting[0];
    if (userSetting !== null) {
      if (userSetting.users?.newSmInitialInfo?.materialIq3Id !== undefined) {
        userSetting.users.newSmInitialInfo.materialIq3Id = materialId;
        await updateUserSetting(userSetting, 0);
      }
    }
  };

  const fetchDataWithImages = async (cad3dList) => {
    await Promise.all(
      cad3dList.map(async (element, i) => {
        try {
          if (element.imageId) {
            if (element.iq3PmxImg === undefined || element.iq3PmxImg === null) {
              // AudiのログインAPIを呼び出して、トークン情報を取得
              let audiLoginToken = props?.hubConnectionToken
                ? props?.hubConnectionToken
                : localStorage?.getItem(IQxRealGoku_AudiToken);
              const imageData = [audiLoginToken, element.imageId];
              const response = await getImageURL(imageData);
              if (response) {
                if (response === 'fail') {
                  // 表示3Dファイルデータを更新する
                  setIQ3DataLst((prevCad3dData) =>
                    prevCad3dData?.map((f) =>
                      f.no === element.no
                        ? {
                            ...f,
                            imageUrl: response,
                          }
                        : f
                    )
                  );
                } else {
                  // 表示3Dファイルデータを更新する
                  setIQ3DataLst((prevCad3dData) =>
                    prevCad3dData?.map((f) =>
                      f.no === element.no
                        ? {
                            ...f,
                            imageUrl: `data:image/png;base64,${response}`,
                          }
                        : f
                    )
                  );
                }
              }
            }
          } else {
            // 表示3Dファイルデータを更新する
            setIQ3DataLst((prevCad3dData) =>
              prevCad3dData?.map((f) =>
                f.id === element.id
                  ? {
                      ...f,
                      imageUrl: 'fail',
                    }
                  : f
              )
            );
          }
        } catch (error) {
          console.error('Error fetching image for', element.name);
        }
      })
    );
    await new Promise((resolve) =>
      setTimeout(async () => {
        setIsGetFileImg(false);
      }, 1000)
    ); // 1秒待機
  };

  // 2025-09-19 IQX_WEBEST-470 表面処理費が表示されないバグ
  const isReCalMaterialFun = async (iq3Row, isChangedProcessSelect = false) => {
    let selectedIq3Data = { ...iq3Row };

    if (isChangedProcessSelect) {
      selectedIq3Data = props?.selectedEstimateData?.esIq3Info?.find((iq3) => iq3?.no === iq3Row?.no);
      setSelectedData(selectedIq3Data);
    }

    if (isDialogOk && activeTabKey !== '6' && !props?.isEstimateOpen) return reCalMaterial.oneRecordCal;

    let oldSelectedEstimateData = iq3MaterialDetailRef?.current?.getSelectedEstimateData();
    if (oldSelectedEstimateData === undefined && !isDialogOk) return reCalMaterial.noCal;

    if (props?.selectedEstimateData?.estimateProducts?.id === 0 && oldSelectedEstimateData === undefined)
      return reCalMaterial.oneRecordCal;

    if (props?.selectedEstimateData?.estimateProducts?.id !== 0 && oldSelectedEstimateData === undefined)
      return reCalMaterial.noCal;

    let oldSelectedData = oldSelectedEstimateData?.esIq3Info?.find((iq3) => iq3.no === selectedIq3Data?.no);

    if (props?.selectedEstimateData?.estimateProducts?.id === 0 && oldSelectedData === undefined)
      return reCalMaterial.noCal;

    if (props?.selectedEstimateData?.estimateProducts?.id !== 0 && oldSelectedData === undefined)
      return reCalMaterial.noCal;

    let oldEstiamteQuantity = oldSelectedEstimateData?.estimateProducts?.quantity || 0;
    let estiamteQuantity = props?.selectedEstimateData?.estimateProducts?.quantity || 0;

    // normalize ids
    oldSelectedData.materialSurfaceIq3Id = oldSelectedData?.materialSurfaceIq3Id || 0;
    selectedIq3Data.materialSurfaceIq3Id = selectedIq3Data?.materialSurfaceIq3Id || 0;

    if (
      oldSelectedData &&
      (Number(oldSelectedData?.partCount) !== Number(selectedIq3Data?.partCount) ||
        Number(oldSelectedData?.materialIq3Id) !== Number(selectedIq3Data?.materialIq3Id) ||
        Number(oldSelectedData?.materialTypeIq3Id) !== Number(selectedIq3Data?.materialTypeIq3Id) ||
        Number(oldSelectedData?.materialSurfaceIq3Id) !== Number(selectedIq3Data?.materialSurfaceIq3Id) ||
        Number(oldSelectedData?.thickness) !== Number(selectedIq3Data?.thickness) ||
        Number(oldSelectedData?.partSizeX) !== Number(selectedIq3Data?.partSizeX) ||
        Number(oldSelectedData?.partSizeY) !== Number(selectedIq3Data?.partSizeY) ||
        Number(oldSelectedData?.grabbingX) !== Number(selectedIq3Data?.grabbingX) ||
        Number(oldSelectedData?.grabbingY) !== Number(selectedIq3Data?.grabbingY) ||
        Number(oldSelectedData?.pierWidthX) !== Number(selectedIq3Data?.pierWidthX) ||
        Number(oldSelectedData?.pierWidthY) !== Number(selectedIq3Data?.pierWidthY) ||
        Number(oldSelectedData?.worlRangeX) !== Number(selectedIq3Data?.worlRangeX) ||
        Number(oldSelectedData?.worlRangeY) !== Number(selectedIq3Data?.worlRangeY))
    ) {
      return reCalMaterial.oneRecordCal;
    } else if (
      Number(estiamteQuantity) !== Number(oldEstiamteQuantity) ||
      props?.isReCalMaterial ||
      (iq3PMXDatas?.length === 0 && props?.isPMXEvent)
    ) {
      if (props?.isReCalMaterial) {
        props?.updateIsRecalMaterial(false);
      }
      return reCalMaterial.allRecordCal;
    }
    return reCalMaterial.noCal;
  };

  // 2025-09-30 IQX_WEBEST-466 DXF読み込み機能追加
  // useEffect(() => {
  //   const handleRecalculation = async () => {
  //     if (props?.pmxRead) {
  //       // setIsDialogOk(true);
  //       // const results = await Promise.all(
  //       //   props?.selectedEstimateData?.esIq3Info?.map((row) => isReCalMaterialFun(row, true))
  //       // );
  //       // console.log('Recalculation results:', results);
  //       // props?.setPmxRead(false);
  //       setIsDialogOk(true);
  //     }
  //   };
  //   handleRecalculation();
  // }, [props?.pmxRead]);

  // iQ3板金タブを選択中で、子部品追加呼出で追加した時
  useEffect(() => {
    const loadData = async () => {
      if (props?.activePartMenu === '2' && !isAddPart) {
        let iq3Infos = props.selectedEstimateData?.esIq3Info;
        if (iq3Infos === undefined) return;
        await fetchDataWithImages(iq3Infos); // 2025-10-06 IQX_WEBEST-466 DXF読み込み機能追加 (親部品リストから再び開くとサムネイルが表示されない)
        setIQ3DataLst(iq3Infos);
      }
    };

    loadData();
  }, [props?.activePartMenu, isAddPart, props?.selectedEstimateData?.esIq3Info]);

  //　新規呼出
  useEffect(() => {
    if (!props.type) {
      // 新規モードの場合、
      if (props.selectedEstimateData?.estimateProducts?.id == 0) {
        initIq3EstimateInfo(props.selectedEstimateData);
      } else {
        // 保存データを開くの場合
        if (props?.selectedEstimateData?.esIq3Info?.length > 0) {
          setIQ3DataLst(props.selectedEstimateData?.esIq3Info);
          setSelectedData(props.selectedEstimateData?.esIq3Info?.[0]);
          setCurrentRecordNo(props.selectedEstimateData?.esIq3Info?.[0]?.no);
          let parameters = props?.selectedEstimateData?.estimateProducts?.calcParameters?.parameters;
          // 材料リスト
          let materialList = parameters?.materialIq3;
          setMaterialLst(materialList);
          if (parameters?.process?.length > 0) {
            let processMstData = getProcessMstInfo(parameters?.process);
            setProcessMasterInfo(processMstData);

            if (parameters?.device?.length > 0) {
              let deviceLst = getDeviceMstInfo(parameters?.device, parameters?.process);
              setDeviceMasterInfo(deviceLst);
            }
          }
          if (parameters?.client?.length > 0) {
            setClientMasterInfo(parameters?.client);
          }
        }
      }
    }
  }, [props.selectedEstimateData, props.type]);

  //基本情報・工程選択・工程入力・工程積算・購入品・材料詳細ダイアログのOKボタンを押した場合、再計算を行う。
  // 行追加・行削除の場合も再計算を行う。
  // useEffect(() => {
  //   if (isDialogOk || reCalByAddDelete || iq3ActionForCal) {
  //     setTimeout(() => {
  //       let calEstimateInfo = updateEstimateInfoByReCal(props.selectedEstimateData, props?.isEstimateOpen);
  //       if (calEstimateInfo) {
  //         // 一覧の情報を反映
  //         if (calEstimateInfo?.esIq3Info) {
  //           const esIq3InfoByRecal = JSON.parse(JSON.stringify(calEstimateInfo?.esIq3Info));
  //           setIQ3DataLst(esIq3InfoByRecal);
  //           // setSelectedData(esIq3InfoByRecal?.[0]);
  //           // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
  //           const selected = currentRecordNo
  //             ? esIq3InfoByRecal.find((x) => x.no === currentRecordNo)
  //             : esIq3InfoByRecal?.[0];

  //           setSelectedData(selected || esIq3InfoByRecal?.[0]);

  //           props.selectedEstimateData.esIq3Info = esIq3InfoByRecal;
  //         }
  //         props.updateEstimateInfo(calEstimateInfo);
  //         props.selectedEstimateData.estimateProducts = calEstimateInfo?.estimateProducts;
  //         setSelectedEstimateData(calEstimateInfo);
  //         setIsDialogOk(false);
  //         setReCalByAddDelete(false);
  //         setIq3ActionForCal(false);
  //         props?.updateIsRecal(false);
  //       }
  //     }, 100);
  //   }
  // }, [isDialogOk, reCalByAddDelete, iq3ActionForCal]);

  // 2025-09-30 IQX_WEBEST-466 DXF読み込み機能追加
  useEffect(() => {
    if (isDialogOk || reCalByAddDelete || iq3ActionForCal) {
      setTimeout(async () => {
        let calEstimateInfo = updateEstimateInfoByReCal(
          props.selectedEstimateData,
          props?.isEstimateOpen,
          props?.hyoumenProcess
        );

        if (calEstimateInfo) {
          // 一覧の情報を反映
          if (calEstimateInfo?.esIq3Info) {
            const esIq3InfoByRecal = JSON.parse(JSON.stringify(calEstimateInfo?.esIq3Info));
            setIQ3DataLst(esIq3InfoByRecal);

            const selected = currentRecordNo
              ? esIq3InfoByRecal.find((x) => x.no === currentRecordNo)
              : esIq3InfoByRecal?.[0];

            setSelectedData(selected || esIq3InfoByRecal?.[0]);
            props.selectedEstimateData.esIq3Info = esIq3InfoByRecal;
          }

          props.updateEstimateInfo(calEstimateInfo);
          props.selectedEstimateData.estimateProducts = calEstimateInfo?.estimateProducts;
          setSelectedEstimateData(calEstimateInfo);

          setIsDialogOk(false);
          setReCalByAddDelete(false);
          setIq3ActionForCal(false);
          props?.updateIsRecal(false);
        }
      }, 100);
    }
  }, [isDialogOk, reCalByAddDelete, iq3ActionForCal]);

  // useEffect(() => {
  //   async function fetchData() {
  //     if (iq3PMXDatas?.length > 0 && props?.isPMXEvent) {
  //       props?.loading(true); // PMXデータ読み取り、完了後Waitingダイアログを非表示にする
  //       let curNo = currentRecordNoPMX;
  //       if (curNo <= iq3PMXDatas?.length) {
  //         let curData = iq3PMXDatas?.filter((item) => item.no === curNo);
  //         if (curData?.length > 0) {
  //           setSelectedData(curData?.[0]);
  //           setCurrentRecordNo(curData?.[0]?.no);
  //           setCurrentRecordNoPMX(curNo + 1);
  //           props.updateIsRecal(true);
  //         }
  //       } else {
  //         setIq3PMXDatas([]);
  //         setCurrentRecordNoPMX(0);
  //         props.updateCheckPMXOrNot();
  //       }
  //     }
  //   }
  //   fetchData();
  // }, [currentRecordNoPMX]);

  // 2025-09-30 IQX_WEBEST-466 DXF読み込み機能追加
  useEffect(() => {
    if (iq3PMXDatas?.length > 0 && props?.isPMXEvent) {
      props?.setFileUploadLoading(true);
      props?.loading(true); // PMXデータ読み取り、完了後Waitingダイアログを非表示にする
      setTimeout(() => {
        let curNo = currentRecordNoPMX;
        if (curNo <= iq3PMXDatas?.length) {
          let curData = iq3PMXDatas?.filter((item) => item.no === curNo);
          if (curData?.length > 0) {
            setSelectedData(curData?.[0]);
            setCurrentRecordNo(curData?.[0]?.no);
            setCurrentRecordNoPMX(curNo + 1);
            props.updateIsRecal(true);
          }
        } else {
          setIq3PMXDatas([]);
          setCurrentRecordNoPMX(0);
          props.updateCheckPMXOrNot();
        }
        props?.setFileUploadLoading(false);
      }, 500);
    }
  }, [currentRecordNoPMX]);

  // useEffect(() => {
  //   if (iq3PMXDatas?.length === 0 && props?.isPMXEvent) {
  //     let calEstimateInfo = await updateEstimateInfoByReCal(props.selectedEstimateData, props?.isEstimateOpen); // IQX_WEBEST-305 過去データを開いた直後、再計算をしない限りはタブ切替しても計算しないでほしい。
  //     if (calEstimateInfo) {
  //       // 一覧の情報を反映
  //       setIQ3DataLst(calEstimateInfo?.esIq3Info);
  //       setSelectedData(calEstimateInfo?.esIq3Info?.[0]);
  //       setCurrentRecordNo(calEstimateInfo?.esIq3Info?.[0]?.no);
  //       props.updateEstimateInfo(calEstimateInfo);
  //       props.selectedEstimateData.estimateProducts = calEstimateInfo?.estimateProducts;
  //       props.selectedEstimateData.esIq3Info = calEstimateInfo?.esIq3Info;
  //       setSelectedEstimateData(calEstimateInfo);
  //     }
  //     props.updateIsRecal(false);
  //     props.updatePMXEvent();
  //   }
  // }, [iq3PMXDatas]);

  // 2025-09-30 IQX_WEBEST-466 DXF読み込み機能追加
  useEffect(() => {
    const handleRecalculation = async () => {
      if (iq3PMXDatas?.length === 0 && props?.isPMXEvent) {
        let calEstimateInfo = updateEstimateInfoByReCal(
          props.selectedEstimateData,
          props?.isEstimateOpen,
          props?.hyoumenProcess
        ); // IQX_WEBEST-305

        if (calEstimateInfo) {
          // 一覧の情報を反映
          setIQ3DataLst(calEstimateInfo?.esIq3Info);
          setSelectedData(calEstimateInfo?.esIq3Info?.[0]);
          setCurrentRecordNo(calEstimateInfo?.esIq3Info?.[0]?.no);

          props.updateEstimateInfo(calEstimateInfo);
          props.selectedEstimateData.estimateProducts = calEstimateInfo?.estimateProducts;
          props.selectedEstimateData.esIq3Info = calEstimateInfo?.esIq3Info;
          setSelectedEstimateData(calEstimateInfo);
        }

        props.updateIsRecal(false);
        // 材料詳細の全件再計算を明示トリガ（PMX/DXF取り込み完了直後の材料費不表示対策）
        if (typeof props.updateIsRecalMaterial === 'function') {
          props.updateIsRecalMaterial(true);
        }
        props.updatePMXEvent();
      }
    };

    handleRecalculation();
  }, [iq3PMXDatas]);

  // IQX_WEBEST-195のパラメータ画面から遷移された場合、アクティブキーを保持するように対応
  // useEffect(() => {
  //   setSelectedTabKey(props?.iq3ActiveTabKey);
  //   onChangeTab(props?.iq3ActiveTabKey);
  //   props?.updateIq3ActiveTabKey(props?.iq3ActiveTabKey);
  //   setIsFirstTimeMaterialDetail(false); // IQX_WEBEST-335 見積りデータ作成中、パラメータ画面と行き来すると選択材料が変わってしまいます。
  // }, [props?.iq3ActiveTabKey]);

  useEffect(() => {
    if (isAddPart) {
      setIsAddPart(false);
      let no = iQ3DataLst?.length > 0 ? iQ3DataLst[iQ3DataLst?.length - 1].no : 0;
      scrollTo(no);
    }
  }, [iQ3DataLst]);

  useEffect(() => {
    if (props?.parentQuantityChangeFlg && props.isReCal) {
      let curNo = currentRecordNoByChangeQty;
      if (curNo <= iQ3DataLst?.length) {
        let curData = iQ3DataLst?.filter((item) => item.no === curNo);
        if (curData?.length > 0) {
          setSelectedData(curData?.[0]);
          setCurrentRecordNo(curData?.[0]?.no);
          setCurrentRecordNoByChangeQty(curNo + 1);
          props.updateIsRecal(true);
        }
      } else {
        if (props?.selectedEstimateData?.esIq3Info?.length > 0) {
          setSelectedData(props.selectedEstimateData?.esIq3Info?.[0]);
          setCurrentRecordNo(props.selectedEstimateData?.esIq3Info?.[0]?.no);
        }
        props.updateParentQuantityChange(false);
        props.updateIsRecal(false);
      }
    }
  }, [props.isReCal]);

  useEffect(() => {
    if (isBulkEditAction) {
      let curNo = currentRecordNoByBultEdit;
      if (curNo <= iQ3DataLst?.length) {
        let curData = iQ3DataLst?.filter((item) => item.no === curNo);
        if (curData?.length > 0) {
          setSelectedData(curData?.[0]);
          setCurrentRecordNo(curData?.[0]?.no);
          setCurrentRecordNoByBultEdit(curNo + 1);
          props.updateIsRecal(true);
        }
      } else {
        let calEstimateInfo = updateEstimateInfoByReCal(
          props.selectedEstimateData,
          props?.isEstimateOpen,
          props?.hyoumenProcess
        ); // IQX_WEBEST-305 過去データを開いた直後、再計算をしない限りはタブ切替しても計算しないでほしい。
        if (calEstimateInfo) {
          // 一覧の情報を反映
          setIQ3DataLst(calEstimateInfo?.esIq3Info);
          setSelectedData(calEstimateInfo?.esIq3Info?.[0]);
          setCurrentRecordNo(calEstimateInfo?.esIq3Info?.[0]?.no);
          props.updateEstimateInfo(calEstimateInfo);
          props.selectedEstimateData.estimateProducts = calEstimateInfo?.estimateProducts;
          props.selectedEstimateData.esIq3Info = calEstimateInfo?.esIq3Info;
          setSelectedEstimateData(calEstimateInfo);
        }
        setIq3ActionForCal(false);
        setIsBulkEditAction(false);
        setCurrentRecordNoByBultEdit(0);
        props.updateIsRecal(false);
      }
    }
  }, [currentRecordNoByBultEdit]);

  const updateIQ3DataByBulkEdit = (bulkEditIQ3Infos) => {
    if (bulkEditIQ3Infos?.length > 0) {
      if (props.selectedEstimateData.esIq3Info) {
        let totalPartCount = bulkEditIQ3Infos?.reduce((total, item) => {
          return total + parseFloat(item.partCount);
        }, 0);
        if (props.selectedEstimateData.estimateProducts) {
          props.selectedEstimateData.estimateProducts.processInput.inspectionProcessInputInfo.smPartsCount =
            totalPartCount;
          props.selectedEstimateData.estimateProducts.processInput.assenbleProcessInputInfo.smPartsCount =
            totalPartCount;
          props.selectedEstimateData.estimateProducts.processInput.packingProcessInputInfo.smPartsCount =
            totalPartCount;
          // IQX_WEBEST-179
          props.selectedEstimateData.estimateProducts.processInput.inspectionProcessInputInfo.autoExtract =
            totalPartCount;
          props.selectedEstimateData.estimateProducts.processInput.assenbleProcessInputInfo.autoExtract =
            totalPartCount;
          props.selectedEstimateData.estimateProducts.processInput.packingProcessInputInfo.autoExtract = totalPartCount;
        }
        setCurrentRecordNoByBultEdit(1);
        setIsBulkEditAction(true);
      }
    }
  };

  // 板金部品見積もりの初期化
  const initIq3EstimateInfo = async (selectedEstimateData) => {
    if (selectedEstimateData === undefined) {
      return;
    }
    let iq3Infos = [];
    if (!props.type) {
      // 新規モードの場合、
      if (selectedEstimateData?.estimateProducts?.id == 0) {
        let iq3Data = [...iq3EstimateInitInfo];
        let newIQ3 =
          selectedEstimateData?.esIq3Info && selectedEstimateData?.esIq3Info?.length > 0 // 親部品タブを選択中で、子部品追加呼出で追加した時
            ? selectedEstimateData?.esIq3Info
            : getNewIQ3EstimateInfo(iq3Data);
        iq3Infos = newIQ3;
        setIQ3DataLst(newIQ3);
      } else {
        //　板金情報リストを取得
        let estimateId = selectedEstimateData?.estimateProducts?.id;
        if (estimateId) iq3Infos = await getEstimateIQ3Data(estimateId);
      }
      selectedEstimateData.esIq3Info = iq3Infos;
      // props.updatedSelectedEstimateDataTemp(selectedEstimateData);
    } else {
      let newIQ3 = selectedEstimateData?.esIq3Info;
      iq3Infos = newIQ3;
      setIQ3DataLst(iq3Infos);
    }
    let selectedData = iq3Infos?.length > 0 ? iq3Infos?.[0] : {};
    // setQuantity(props?.getParentQuantity()); // 入力した数量情報を得る
    setSelectedEstimateData(selectedEstimateData);
    setCurrentRecordNo(selectedData?.no ? selectedData?.no : 1);
    setSelectedData(selectedData);

    let parameters = selectedEstimateData?.estimateProducts?.calcParameters?.parameters;
    // 材料リスト
    let materialList = parameters?.materialIq3;
    setMaterialLst(materialList);

    if (parameters?.process?.length > 0) {
      let processMstData = getProcessMstInfo(parameters?.process);
      setProcessMasterInfo(processMstData);

      if (parameters?.device?.length > 0) {
        let deviceLst = getDeviceMstInfo(parameters?.device, parameters?.process);
        setDeviceMasterInfo(deviceLst);
      }
    }
    if (parameters?.client?.length > 0) {
      setClientMasterInfo(parameters?.client);
    }
  };

  // 材料マスタ情報
  const getProcessMstInfo = (process) => {
    let processMstData = process?.filter((process) => process?.class === ServiceClass.SheetMetal);
    return processMstData;
  };

  // 装置マスタ情報
  const getDeviceMstInfo = (device, process) => {
    let processMstData = getProcessMstInfo(process);
    let deviceLst = device?.filter((item) => processMstData?.filter((process) => process?.id === item?.processId));
    return deviceLst;
  };

  // 新規モードの場合、板金部品情報を初期化する
  const getNewIQ3EstimateInfo = (lists) => {
    let parameters = props.selectedEstimateData?.estimateProducts?.calcParameters?.parameters;
    let userSettingData = props.selectedEstimateData?.estimateProducts?.calcParameters?.settings?.userSettings;

    const patternLst = parameters?.processPattern; // 工程パターンマスタデータ
    let kouteiPatternList = patternLst?.filter((item) => item.id === userSettingData?.[0]?.users?.iq3ProcessPatternId);
    // IQX_WEBEST-323 新規処理の前回値の採用
    if (userSettingData?.length > 0 && userSettingData?.[0].users.newSmInitialInfo.iq3ProcessPatternId !== undefined) {
      let userSettingProcessPattern = patternLst?.filter(
        (i) => i.id === userSettingData?.[0].users.newSmInitialInfo.iq3ProcessPatternId
      );
      kouteiPatternList = userSettingProcessPattern?.length > 0 ? userSettingProcessPattern : kouteiPatternList;
    }
    if (kouteiPatternList?.length === 0) {
      kouteiPatternList = patternLst?.filter((item) => item.class === ServiceClass.SheetMetal);
    }

    const materialType = parameters?.materialTypeIq3; // 材質マスタデータ
    let materialTypeList = materialType?.filter((item) => item.info.isUsed);

    const material = parameters?.materialIq3; // 材料マスタデータ
    let materialList = material?.filter(
      (item) =>
        item.info.isUsed && item.materialTypeIq3Id === (materialTypeList?.length > 0 ? materialTypeList[0]?.id : 0)
    );

    const materialSurface = parameters?.materialSurfaceIq3; // 材料表面マスタデータ
    let materialSurfaceList = materialSurface?.filter(
      (item) =>
        item.info.isUsed && item.materialTypeIq3Id === (materialTypeList?.length > 0 ? materialTypeList[0]?.id : 0)
    );
    // IQX_WEBEST-323 新規処理の前回値の採用
    let materialIq3Id = materialList?.length > 0 ? materialList[0]?.id : 0;
    let materialName = materialList?.length > 0 ? materialList[0]?.name : '';
    let materialTypeIq3Id_sm = materialTypeList?.length > 0 ? materialTypeList[0]?.id : 0;
    let materialTypeName = materialTypeList?.length > 0 ? materialTypeList[0]?.name : '';
    let thickness = materialList?.length > 0 ? materialList[0]?.id : 0;
    // 前回値の材料名称
    if (userSettingData?.length > 0 && userSettingData?.[0].users.newSmInitialInfo.materialIq3Id !== undefined) {
      // 前回値の材料名称
      let userSettingMaterial = material?.filter(
        (i) => i.id === userSettingData?.[0].users.newSmInitialInfo.materialIq3Id
      );
      materialIq3Id = userSettingMaterial?.length > 0 ? userSettingMaterial[0]?.id : materialIq3Id;
      materialName = userSettingMaterial?.length > 0 ? userSettingMaterial[0]?.name : materialName;
      // 前回値の材料名称に該当する材質名称
      let userSettingMaterialTypeIq3 = materialTypeList?.filter(
        (i) => i.id === userSettingMaterial[0]?.materialTypeIq3Id
      );
      materialTypeIq3Id_sm = userSettingMaterialTypeIq3?.length > 0 ? userSettingMaterialTypeIq3[0]?.id : 0;
      materialTypeName = userSettingMaterialTypeIq3?.length > 0 ? userSettingMaterialTypeIq3[0]?.name : '';
      // 前回値の材料名称に該当する板厚
      thickness = userSettingMaterial?.length > 0 ? userSettingMaterial[0]?.id : 0;
    }
    // 前回値の表面保護
    let materialSurfaceIq3Id = materialSurfaceList?.length > 0 ? materialSurfaceList[0]?.id : 0;
    let materialSurfaceName = materialSurfaceList?.length > 0 ? materialSurfaceList[0]?.name : '';
    if (userSettingData?.length > 0 && userSettingData?.[0].users.newSmInitialInfo.materialSurfaceIq3Id !== undefined) {
      let userSettingMaterialSurfaceIq3 = materialSurface?.filter(
        (i) => i.info.isUsed && i.id === userSettingData?.[0].users.newSmInitialInfo.materialSurfaceIq3Id
      );
      materialSurfaceIq3Id =
        userSettingMaterialSurfaceIq3?.length > 0 ? userSettingMaterialSurfaceIq3[0]?.id : materialSurfaceIq3Id;
      materialSurfaceName =
        userSettingMaterialSurfaceIq3?.length > 0 ? userSettingMaterialSurfaceIq3[0]?.name : materialSurfaceName;
    }

    // 工程マスタ情報取得
    let processMaster = [];
    const processMstData = parameters?.process; // 工程マスタデータ
    processMaster = processMstData?.filter((process) => process?.class === ServiceClass.SheetMetal);
    let blankIsUsedData = [];
    processMaster?.filter((i) => {
      if (
        i.workType === WorkType.SmBlankCombi ||
        i.workType === WorkType.SmBlankLaser ||
        i.workType === WorkType.SmBlankPunch
      ) {
        blankIsUsedData.push(i.id);
        // return i.id;
      }
    });
    const filteredList2 = kouteiPatternList?.[0]?.details?.filter((item2) =>
      blankIsUsedData.some((item1) => item1 === item2.processId)
    );

    const isAnyTrue = filteredList2?.some((item) => item.isUsedForCalc);

    // 工程入力
    let processSelectDetails = kouteiPatternList?.[0]?.details;

    let kouteiInputArr = [];
    if (processSelectDetails) {
      kouteiInputArr = processSelectDetails?.map((item, index) => {
        const processMstInfo = processMaster?.filter((i) => i.id === item.processId)?.[0] || [];

        const workType = processMstInfo.workType || '';

        let data = {
          id: index + 1,
          processId: item.processId,
          details: getDetails(workType, parameters, processSelectDetails),
          autoExtractXSize: 0,
          autoExtractYSize: 0,
        };

        return data;
      });
    }

    //　工程積算
    let kouteiCalArr = [];
    if (processSelectDetails) {
      kouteiCalArr = processSelectDetails?.map((item, index) => {
        const processMstInfo = processMaster?.filter((i) => i.id === item.processId)?.[0] || [];

        const workType = processMstInfo.workType || '';
        let dataItems = [];
        if (item.multiprocesses?.length > 0) {
          for (let m = 0; m < item.multiprocesses?.length; m++) {
            let dataItem = {
              id: m + 1,
              processName: processMstInfo?.name,
              processDetailTypeNo: item.multiprocesses[m]?.processDetailTypeId,
              dandoriAmt: 0,
              dandoriTime: 0,
              sagyoAmt: 0,
              sagyoTime: 0,
              processDetailWorkTypeGroup: item.multiprocesses[m]?.processDetailGroup,
              kasho: 1,
              isCommission: false,
              supplier: '',
              supplierCode: '',
              formula: '',
            };
            dataItems.push(dataItem);
          }
        }

        let addition = {
          no: item.processId,
          processId: item.processId,
          dataType: DataType.Data,
          dataItems: dataItems,
          editItems: [],
          totalDandori: {
            dataItemsAmt: 0,
            dataItemsTime: 0,
            editItemsAmt: 0,
            editItemsTime: 0,
          },
          totalSagyo: {
            dataItemsAmt: 0,
            dataItemsTime: 0,
            editItemsAmt: 0,
            editItemsTime: 0,
          },
          totalDataPrice: 0,
          totalDataTime: 0,
          totalEditPrice: 0,
          totalEditTime: 0,
          editDataFlg: false,
        };

        return addition;
      });
    }

    // ブランクの場合
    let blankProcess = getProcessRecord(
      ServiceClass.SheetMetal,
      [WorkType.SmBlankLaser, WorkType.SmBlankPunch, WorkType.SmBlankCombi], // レーザー、パンチ、複合機
      processMstData
    );
    // 板金工程選択にブランクを使用している場合、
    let usedBlankProcess = processSelectDetails?.find(
      (selectItem) =>
        selectItem.isUsedForCalc && blankProcess?.findIndex((item) => item.id === selectItem.processId) > -1
    );
    // 使用している装置の情報を取得する
    let usedDeviceInfo = parameters?.device?.find((device) => device.id === usedBlankProcess?.deviceId);
    let grabbingX = 0;
    let grabbingY = 0;
    let pierWidthX = 0;
    let pierWidthY = 0;
    let worlRangeX = 0;
    let worlRangeY = 0;
    // 装置がある場合、
    if (usedDeviceInfo) {
      // 装置から材料配置情報
      let materialArrange = usedDeviceInfo?.details?.materialArrange;
      grabbingX = materialArrange?.graspAllowanceX;
      grabbingY = materialArrange?.graspAllowanceY;
      pierWidthX = materialArrange?.xWidth;
      pierWidthY = materialArrange?.yWidth;
      worlRangeX = materialArrange?.workRangeX;
      worlRangeY = materialArrange?.workRangeY;
    }

    // 材料詳細パターン情報を準備する
    let materialDetailPatterns = [];

    // 材料詳細サイズリスト情報を準備する
    let materialDetailSizes = [];
    let materialSizeIq3Infos = parameters?.materialSizeIq3;

    const updatedList = lists?.map((i, index) => {
      if (i?.id === 0) {
        materialDetailSizes = [];
        let materialTypeIq3Id = materialTypeList?.length > 0 ? materialTypeList[0]?.id : 0;
        if (materialSizeIq3Infos) {
          materialDetailSizes = materialSizeIq3Infos
            ?.filter(
              (item) =>
                item.info.isUsed &&
                item.name !== 'Free' &&
                item?.materialTypeIq3Id?.findIndex(
                  (id) => id === (i.materialTypeIq3Id === 0 ? materialTypeIq3Id : i.materialTypeIq3Id)
                ) > -1
            )
            ?.map((item, index) => {
              let data = getInitMaterialSizeInfo(index, item);
              let copyItem = JSON.parse(JSON.stringify(item));
              if (data?.sizeName === 'Other') {
                data = { ...data, isUsed: true };
                // /材料サイズX計算
                let sheetX = Number(0) + Number(pierWidthX) + Number(grabbingX);
                // /材料サイズY計算
                let sheetY = Number(0) + Number(pierWidthY) + Number(grabbingY);
                copyItem = { ...copyItem, info: { ...copyItem.info, sizeX: sheetX, sizeY: sheetY } };
              }
              materialDetailPatterns = getInitMaterialPatternsInfo(materialDetailPatterns, copyItem);
              return data;
            });
        }

        i.no = 1;
        i.creationType = EstimateCreationType.Auto;
        i.drawingNo = 'Part_' + formatDateString(todayTime());
        i.name = 'Part_' + padWithLeadingZeros(index + 1, 5);
        i.surfaceProtection = SurfaceProtectionType.OneSideVinyl;
        if (!props?.isPMXEvent && !(props?.selectedEstimateData?.esIq3Info?.length > 0)) {
          i.materialIq3Id = materialIq3Id;
          i.materialName = materialName;
          i.materialTypeIq3Id = materialTypeIq3Id_sm;
          i.materialTypeName = materialTypeName;
          i.materialSurfaceIq3Id = materialSurfaceIq3Id;
          i.materialSurfaceName = materialSurfaceName;
          i.thickness = thickness;
        }
        i.processSelect = {
          id: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.id : 0,
          name: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.name : '',
          details: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.details : [],
          modified: kouteiPatternList?.length > 0 ? kouteiPatternList[0]?.modified : dayjs().format(),
        };
        i.processInput = kouteiInputArr;
        i.purchases = [];
        i.additions = kouteiCalArr;
        i.materialDetailPatterns = materialDetailPatterns;
        i.materialDetailSizes = materialDetailSizes;
        i.weight = 0;
        i.totalSurfaceArea = 0.0;
        i.partSizeX = 0;
        i.partSizeY = 0;
        i.partCount = 1;
        i.grabbingX = grabbingX;
        i.grabbingY = grabbingY;
        i.pierWidthX = pierWidthX;
        i.pierWidthY = pierWidthY;
        i.worlRangeX = worlRangeX;
        i.worlRangeY = worlRangeY;
        i.workCostUnitPrice = 0;
        i.workCostTotalPrice = 0;
        i.costUnitPrice = 0;
        i.costTotalPrice = 0;
        i.surfaceTotalPrice = 0;
        i.surfaceUnitPrice = 0;
        i.purchaseUnitPrice = 0;
        i.purchaseTotalPrice = 0;
        i.materialCostUnitPrice = 0;
        i.materialCostTotalPrice = 0;
        // 2025-05-27 工程入力で何かしら数値や項目を変更した後、部品リストに変更したことがわかるように表示がほしい。
        i.isChangedProcessInput = false;
        // 2025-05-27 一括編集にて材料費￥０に編集したい。できないか？の対応
        // i.isZeroMaterialCost = false;
      }
      return i;
    });
    return updatedList;
  };

  // 工程マスタのレコードIDを取得する
  const getProcessRecord = (classId, processTypes, mstInfo) => {
    // 選択された、種別と工程より工程マスタレコードIDを得る
    let mstRecordInfo = [...mstInfo]?.filter(
      (item) => item?.class === classId && processTypes?.findIndex((workType) => workType === item?.workType) > -1
    );
    return mstRecordInfo;
  };

  // 板金部品見積もりを取得する
  const getEstimateIQ3Data = async (estimateProductId) => {
    let estimateIq3Infos = await getEstimateIq3Info(estimateProductId);
    if (estimateIq3Infos) {
      setIQ3DataLst(estimateIq3Infos);
    }
    return estimateIq3Infos;
  };

  // Scrollの移動
  const scrollTo = (rowKey) => {
    // Scrollの移動
    var activeRowElements = document.getElementById('iq3EstimateTbl').getElementsByClassName('ant-table-row');
    for (let i = 0; i < activeRowElements?.length; i++) {
      var targetElement = activeRowElements[i].dataset.rowKey == rowKey ? activeRowElements[i] : [];
      if (targetElement != '') {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'end' });
      }
    }
  };

  // 編集中破棄確認ポップアップのOKボタン押下
  const discardConfirmOk = () => {
    setEditModeCancelConfirm(false);
    props.updateMainEstimateEditMode(false);
    onChangeTab(selectedTabKey);
    props?.updateIq3ActiveTabKey(selectedTabKey);
    getAllEstimateIq3Info();
  };

  // 編集中破棄確認ポップアップのCancelボタン押下
  const discardConfirmCancel = () => {
    setEditModeCancelConfirm(false);
  };

  // 部品リストの行を選択した場合、
  const onRowSelect = (record) => {
    setCurrentRecordNo(record.no);
    setSelectedData(record);
  };

  // 選択中であり、部品の各タブ情報をリストに反映するようにする
  const getAllEstimateIq3Info = () => {
    setConfirmMsgOpen(false);
    props.updateMainEstimateEditMode(false);

    let estimateData = { ...props.selectedEstimateData };
    let selectedIq3EstimateData = estimateData?.esIq3Info?.find((iq3) => iq3?.no === selectedData?.no);

    // 工程積算
    //工程パターンでチェック外した工程を工程積算から削除
    let orgAdditions = estimateData?.esIq3Info?.filter((item) => item.no === selectedIq3EstimateData?.no)?.[0]
      ?.additions;
    let updatedAdditions = [];
    for (let i = 0; i < selectedIq3EstimateData?.processSelect?.details?.length; i++) {
      let targetAddition = orgAdditions?.filter(
        (item) =>
          item.processId === selectedIq3EstimateData?.processSelect?.details[i].processId &&
          selectedIq3EstimateData?.processSelect?.details[i].isUsedForCalc
      );
      if (targetAddition?.length > 0) {
        //複数処理（追加工程）の場合、工程IDで判断できないため、工程詳細IDで判断して対象データを取得
        if (targetAddition?.length > 1) {
          for (let o = 0; o < orgAdditions?.length; o++) {
            let customProc = estimateData?.estimateProducts?.calcParameters?.parameters?.process?.filter(
              (item) => item.id === orgAdditions[o]?.processId
            );
            let customType = customProc ? customProc[0]?.workType : 0;
            if (
              selectedIq3EstimateData?.processSelect?.details[i]?.multiprocesses?.[0]?.processDetailTypeId ===
                orgAdditions[o]?.dataItems?.[0]?.processDetailTypeNo &&
              selectedIq3EstimateData?.processSelect?.details[i]?.processId === orgAdditions[o]?.processId &&
              customType === WorkType.SmCustom
            ) {
              updatedAdditions?.push(orgAdditions?.[o]);
              break;
            }
          }
        } else {
          updatedAdditions?.push(targetAddition?.[0]);
        }
      }
    }
    if (selectedIq3EstimateData?.processSelect?.details?.length > 0) {
      //工程選択から外した場合、見積データに外した情報を更新するため、updatedAdditionsのNullチェックを削除
      selectedIq3EstimateData.additions = updatedAdditions;
    }

    // 材料詳細
    // if (iq3MaterialDetailRef?.current) {
    //   const materialDetailInfo = iq3MaterialDetailRef?.current?.getIQ3MaterialDetailInfo();
    //   let materialPatterns = materialDetailInfo?.materialDetailPatterns;
    //   let materialSizes = materialDetailInfo?.materialDetailSizes;

    //   if (activeTabKey !== '1' && materialDetailInfo) {
    //     if (selectedIq3EstimateData.materialIq3Id !== materialDetailInfo?.materialIq3Id)
    //       selectedIq3EstimateData.materialIq3Id = materialDetailInfo?.materialIq3Id;
    //     if (selectedIq3EstimateData.materialName !== materialDetailInfo?.materialName)
    //       selectedIq3EstimateData.materialName = materialDetailInfo?.materialName;
    //     if (selectedIq3EstimateData.materialTypeIq3Id !== materialDetailInfo?.materialTypeIq3Id)
    //       selectedIq3EstimateData.materialTypeIq3Id = materialDetailInfo?.materialTypeIq3Id;
    //     if (selectedIq3EstimateData.materialTypeName !== materialDetailInfo?.materialTypeName)
    //       selectedIq3EstimateData.materialTypeName = materialDetailInfo?.materialTypeName;
    //     if (selectedIq3EstimateData.materialSurfaceIq3Id !== materialDetailInfo?.materialSurfaceIq3Id)
    //       selectedIq3EstimateData.materialSurfaceIq3Id = materialDetailInfo?.materialSurfaceIq3Id;
    //     if (selectedIq3EstimateData.materialSurfaceName !== materialDetailInfo?.materialSurfaceName)
    //       selectedIq3EstimateData.materialSurfaceName = materialDetailInfo?.materialSurfaceName;
    //     if (selectedIq3EstimateData.thickness !== materialDetailInfo?.thickness)
    //       selectedIq3EstimateData.thickness = materialDetailInfo?.thickness;
    //   }
    //   if (materialDetailInfo) {
    //     let selectedMaterialSizeInfo;
    //     let materialTotalPrice = 0; // 材料原価合計
    //     let materialUnitPrice = 0; // // 材料原価
    //     if (materialSizes && materialSizes.length > 0) {
    //       selectedMaterialSizeInfo = materialSizes.find((item) => item.isUsed); // 採用されるサイズの情報
    //       if (selectedMaterialSizeInfo) {
    //         materialTotalPrice = selectedMaterialSizeInfo?.price; // 材料原価合計
    //         materialUnitPrice = materialTotalPrice / (selectedIq3EstimateData?.partCount * props.getParentQuantity()); // 材料原価/員数＊数量
    //       }
    //     }
    //     selectedIq3EstimateData.grabbingX = materialDetailInfo?.grabbingX;
    //     selectedIq3EstimateData.grabbingY = materialDetailInfo?.grabbingY;
    //     selectedIq3EstimateData.pierWidthX = materialDetailInfo?.pierWidthX;
    //     selectedIq3EstimateData.pierWidthY = materialDetailInfo?.pierWidthY;
    //     selectedIq3EstimateData.materialCostUnitPrice =
    //       materialUnitPrice && !isInfinity(materialUnitPrice) ? materialUnitPrice : 0; // 材料原価
    //     selectedIq3EstimateData.materialCostTotalPrice =
    //       materialTotalPrice && !isInfinity(materialTotalPrice) ? materialTotalPrice : 0; // 材料原価合計
    //     selectedIq3EstimateData.materialDetailPatterns = materialPatterns ? materialPatterns : [];
    //     selectedIq3EstimateData.materialDetailSizes = materialSizes ? materialSizes : [];
    //   }
    // }

    // 一覧の情報を反映するため、データ取得
    let updatedData = estimateData?.esIq3Info;
    let data = [...iQ3DataLst];
    if (data?.length > 0) {
      updatedData = data?.map((item) => {
        if (item.no === selectedIq3EstimateData?.no) {
          item = selectedIq3EstimateData;
        }
        // IQX_WEBEST-286 自動：工程積算タブでデータ欄を使用している状態
        let isManual = false;
        for (let i = 0; i < item?.additions?.length; i++) {
          let eqAddition = item?.additions[i];
          if (eqAddition?.dataType) {
            isManual = true;
            break;
          }
        }
        if (isManual) {
          item.creationType = EstimateCreationType.Manual;
        } else {
          item.creationType = EstimateCreationType.Auto;
        }
        return item;
      });
    }

    estimateData = { ...estimateData, esIq3Info: updatedData };
    if (estimateData) {
      //タブ切替で再計算
      // let calEstimateInfo = updateEstimateInfoByReCal(estimateData, props?.isEstimateOpen); // IQX_WEBEST-305 過去データを開いた直後、再計算をしない限りはタブ切替しても計算しないでほしい。
      // if (calEstimateInfo) {
      //   // 一覧の情報を反映
      //   setIQ3DataLst(calEstimateInfo?.esIq3Info);
      //   calEstimateInfo?.esIq3Info?.map((item) => {
      //     if (item.no === selectedIq3EstimateData?.no) {
      //       // 選択中の部品情報を反映
      //       setSelectedData(item);
      //     }
      //   });

      // }
      props.updateEstimateInfo(estimateData);
      props.selectedEstimateData.estimateProducts = estimateData?.estimateProducts;
      props.selectedEstimateData.esIq3Info = estimateData?.esIq3Info;
      setSelectedEstimateData(estimateData);
      return estimateData;
    }
  };

  const confirmOk = (e) => {
    getAllEstimateIq3Info();
  };

  const confirmCancel = () => {
    setConfirmMsgOpen(false);
    // props.childEditMode(false);
  };

  // 開発中ポップアップ
  const closeCommonTaiochuPopup = () => {
    setOpenCommonTaiochuPopup(false);
  };

  // 工程選択画面の工程リストを選択した場合、
  const updateSelectedData = (selectedPartNo) => {
    getAllEstimateIq3Info(); // タブの切り替えで入力中の情報を保持するようにする
    let selectedData = iQ3DataLst?.filter((item) => item.no == selectedPartNo);
    setCurrentRecordNo(selectedPartNo);
    setSelectedData(selectedData?.length > 0 ? selectedData[0] : iQ3DataLst[0]);
    scrollTo(selectedPartNo);
  };

  // 工程選択画面のイベント変更により呼出
  const updateProcessSelectOfSelectedData = (processSelect) => {
    setSelectedProcessSelect(processSelect);
  };

  // import PMX file
  const importPMXFile = (pmxData) => {
    setIQ3DataLst(pmxData);
    setCurrentRecordNo(0);
    setSelectedData(pmxData[0]);
    navigate(':estimate.iq3');
  };

  const kihonFormValidation = () => {
    let validation = iq3DetailRef?.current?.formValidation;
    return validation;
  };

  useImperativeHandle(ref, () => ({
    importPMXFile: importPMXFile,
    getIQ3EditMode: () => {
      return editMode;
    },
    getIQ3EstimateDetailInfo: getAllEstimateIq3Info,
    getEstimateIq3Info: () => {
      return iQ3DataLst;
    },
    kihonFormValidation: kihonFormValidation,
    updateIq3PMXDatas: updateIq3PMXDatas,
    getIQ3ActiveTabKey: () => {
      return activeTabKey;
    },
    updateIQ3DataByBulkEdit: updateIQ3DataByBulkEdit,
    getNewIQ3EstimateInfo: getNewIQ3EstimateInfo,
    updateIq3ActionForCal: updateIq3ActionForCal,
  }));

  // 部品追加ボタンの押下
  const addPart = async () => {
    // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
    const partCount = props?.companySettingInfo?.[0]?.environments?.isAddMultipleChildParts ? recordNum : 1;
    let iq3Data = [...iq3EstimateInitInfo];
    var copyPart = getNewIQ3EstimateInfo(JSON.parse(JSON.stringify(iq3Data)));
    if (copyPart?.length > 0) copyPart = copyPart[0];
    if (props?.selectedEstimateData?.esIq3Info != undefined && props?.selectedEstimateData?.esIq3Info?.length > 0) {
      let tempIQ3List = [...props?.selectedEstimateData?.esIq3Info];
      var lastRecord = tempIQ3List.sort((a, b) => b.no - a.no)?.[0];
      // copyPart = {
      //   ...copyPart,
      //   no: lastRecord?.no + 1,
      //   name: 'Part_' + padWithLeadingZeros(lastRecord?.no + 1, 5),
      //   materialCostUnitPrice: 0,
      //   materialCostTotalPrice: 0,
      //   costUnitPrice: 0,
      // };
      // let tempIQ3DataLst = [...iQ3DataLst];
      // tempIQ3DataLst?.push(copyPart);
      // // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
      // setCurrentRecordNo(lastRecord?.no + 1);
      // setIQ3DataLst(tempIQ3DataLst);
      // props?.selectedEstimateData?.esIq3Info?.push(copyPart);

      // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
      let newParts = [];
      for (let i = 0; i < partCount; i++) {
        let newPart = {
          ...copyPart,
          no: lastRecord?.no + i + 1, // Increment 'no' by i
          name: 'Part_' + padWithLeadingZeros(lastRecord?.no + i + 1, 5),
          materialCostUnitPrice: 0,
          materialCostTotalPrice: 0,
          costUnitPrice: 0,
        };
        newParts.push(newPart);
      }

      let tempiQ3DataLst = [...iQ3DataLst, ...newParts];
      // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
      setCurrentRecordNo(lastRecord?.no + 1);
      setIQ3DataLst(tempiQ3DataLst);

      props?.selectedEstimateData?.esIq3Info?.push(...newParts);
    } else {
      // copyPart = {
      //   ...copyPart,
      //   no: 1,
      //   materialCostUnitPrice: 0,
      //   materialCostTotalPrice: 0,
      //   costUnitPrice: 0,
      // };
      // let tempIQ3DataLst = [...iQ3DataLst];
      // tempIQ3DataLst?.push(copyPart);
      // // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
      // setCurrentRecordNo(1);
      // setIQ3DataLst(tempIQ3DataLst);
      // props?.selectedEstimateData?.esIq3Info?.push(copyPart);

      let newParts = [];
      for (let i = 0; i < partCount; i++) {
        let newPart = {
          ...copyPart,
          no: i + 1,
          materialCostUnitPrice: 0,
          materialCostTotalPrice: 0,
          costUnitPrice: 0,
        };
        newParts.push(newPart);
      }

      let tempiQ3DataLst = [...iQ3DataLst, ...newParts];
      // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
      setCurrentRecordNo(1);
      setIQ3DataLst(tempiQ3DataLst);

      props?.selectedEstimateData?.esIq3Info?.push(...newParts);
    }
    setIsAddPart(true);
    setSelectedEstimateData(props.selectedEstimateData);
    // IQX_WEBEST-179
    calculateChildPartCount();
    calculateWeightAreaForPaSurface();
    // 部品追加により再計算
    setReCalByAddDelete(true);
    props.updateIsRecal(true);
  };

  // 部品削除ボタンの押下
  const deletePart = () => {
    if (iQ3DataLst?.length <= 1) return;
    let deletePart =
      props?.userSettingInfo?.[0]?.massages?.deletePart == undefined
        ? true
        : props?.userSettingInfo?.[0]?.massages?.deletePart;
    setIsDelete(deletePart);
    if (!deletePart) {
      deleteOk();
    }
  };

  // 削除ポップアップのOKボタンの押下
  const deleteOk = () => {
    setIsDelete(false);
    let tempIQ3List = [...iQ3DataLst];
    tempIQ3List = tempIQ3List?.filter((item) => item.no !== currentRecordNo);
    tempIQ3List = tempIQ3List?.map((item, index) => {
      return { ...item, no: index + 1 };
    });
    setIQ3DataLst(tempIQ3List);
    setSelectedEstimateData((prev) => ({ ...prev, esIq3Info: tempIQ3List }));
    if (tempIQ3List?.length > 0) {
      // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
      const sortedList = [...tempIQ3List].sort((a, b) => a.no - b.no);
      const deletedIndex = sortedList.findIndex((item) => item.no === currentRecordNo - 1);
      const newIndex = deletedIndex > 0 ? deletedIndex : 0;
      const nextSelected = sortedList[newIndex];

      setCurrentRecordNo(nextSelected?.no || 0);
      setSelectedData(nextSelected);
    }
    if (props.selectedEstimateData.esIq3Info) {
      props.selectedEstimateData.esIq3Info = tempIQ3List;
    }
    // IQX_WEBEST-179
    calculateChildPartCount();
    calculateWeightAreaForPaSurface();
    // 部品削除により再計算
    setReCalByAddDelete(true);
    props.updateIsRecal(true);
  };

  // 削除ポップアップのCancelボタンの押下
  const deleteCancel = () => {
    setIsDelete(false);
  };

  // 部品複写追加ボタンの押下(IQX_WEBEST-311 板金子部品の「部品複写追加」機能の追加)
  const addCopyPart = async () => {
    let tempIQ3List = JSON.parse(JSON.stringify(props?.selectedEstimateData?.esIq3Info));
    var copyPart = tempIQ3List?.filter((item) => item.no === currentRecordNo);
    if (tempIQ3List != undefined && tempIQ3List?.length > 0 && copyPart?.length > 0) {
      copyPart = JSON.parse(JSON.stringify(copyPart[0]));
      var lastRecord = tempIQ3List.sort((a, b) => b.no - a.no)?.[0];

      // copyPart.no = lastRecord?.no + 1;
      // copyPart.drawingNo = 'Part_' + formatDateString(todayTime()); // IQX_WEBEST-311 部品複写機能で新たに追加された子部品の子部品図番と子部品名称は、新規子部品追加時と同様
      // copyPart.name = 'Part_' + padWithLeadingZeros(lastRecord?.no + 1, 5); // IQX_WEBEST-311 部品複写機能で新たに追加された子部品の子部品図番と子部品名称は、新規子部品追加時と同様
      // let tempIQ3DataLst = [...iQ3DataLst];
      // tempIQ3DataLst?.push(copyPart);
      // setIQ3DataLst(tempIQ3DataLst);
      // props?.selectedEstimateData?.esIq3Info?.push(copyPart);
      // setIsAddPart(true);
      // setSelectedEstimateData(props.selectedEstimateData);

      // // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
      // setCurrentRecordNo(lastRecord?.no + 1);
      // setSelectedData(copyPart);

      // calculateChildPartCount();
      // calculateWeightAreaForPaSurface();
      // // 部品複写により再計算
      // setReCalByAddDelete(true);
      // props.updateIsRecal(true);

      // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
      const copiesToAdd = props?.companySettingInfo?.[0]?.environments?.isAddMultipleChildParts ? recordNum : 1;

      // const copiesToAdd = recordNum;
      let newParts = [];
      for (let i = 0; i < copiesToAdd; i++) {
        // Create a copy of the part and update the 'no' value
        let newCopyPart = { ...copyPart };
        newCopyPart.no = lastRecord?.no + 1 + i; // Increment 'no' for each copy
        newCopyPart.drawingNo = 'Part_' + formatDateString(todayTime()); // Set a new drawingNo for each copy
        newCopyPart.name = 'Part_' + padWithLeadingZeros(lastRecord?.no + 1 + i, 5); // Update part name with new 'no'

        newParts.push(newCopyPart);
      }

      let tempiQ3DataLst = [...iQ3DataLst];
      tempiQ3DataLst = tempiQ3DataLst?.concat(newParts); // Add all new copies to the list
      setIQ3DataLst(tempiQ3DataLst);

      // Update the selected estimate data
      props?.selectedEstimateData?.esIq3Info?.push(...newParts);
      setIsAddPart(true);
      setSelectedEstimateData(props.selectedEstimateData);

      // 2025-06-27 IQX_WEBEST-427 子部品を追加/削除すると選択される部品を修正してほしい
      setCurrentRecordNo(lastRecord?.no + 1);
      setSelectedData(copyPart);

      calculateChildPartCount();
      calculateWeightAreaForPaSurface();

      // 部品複写により再計算
      setReCalByAddDelete(true);
      props.updateIsRecal(true);

      // 2025-09-11 IQX_WEBEST-468 正確に複写されないバグ
      setIsDialogOk(true);
    }
  };

  const calculateChildPartCount = () => {
    let childpart = 0;
    if (props?.selectedEstimateData?.esIq3Info?.length > 0) {
      childpart = props?.selectedEstimateData?.esIq3Info?.reduce((total, item) => {
        return total + parseInt(item.partCount);
      }, 0);
    }
    if (props?.selectedEstimateData?.estimateProducts?.processInput != undefined) {
      props.selectedEstimateData.estimateProducts.processInput.inspectionProcessInputInfo.smPartsCount = childpart;
      props.selectedEstimateData.estimateProducts.processInput.assenbleProcessInputInfo.smPartsCount = childpart;
      props.selectedEstimateData.estimateProducts.processInput.packingProcessInputInfo.smPartsCount = childpart;
      // IQX_WEBEST-179
      props.selectedEstimateData.estimateProducts.processInput.inspectionProcessInputInfo.autoExtract = childpart;
      props.selectedEstimateData.estimateProducts.processInput.assenbleProcessInputInfo.autoExtract = childpart;
      props.selectedEstimateData.estimateProducts.processInput.packingProcessInputInfo.autoExtract = childpart;
    }
  };

  const calculateWeightAreaForPaSurface = () => {
    let totalWeight = 0;
    let totalArea = 0;
    totalWeight = props?.selectedEstimateData?.esIq3Info?.reduce((total, item) => {
      return total + parseFloat(item.weight * Number(item.partCount)); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
    }, 0);
    totalArea = props?.selectedEstimateData?.esIq3Info?.reduce((total, item) => {
      return total + parseFloat(item.totalSurfaceArea * Number(item.partCount)); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
    }, 0);
    if (totalWeight === 0 && totalArea === 0) {
    } else {
      if (props?.selectedEstimateData?.estimateProducts?.processInput?.surfaceProcessInputInfo?.length > 0) {
        let parentSurfaceData =
          props?.selectedEstimateData?.estimateProducts?.processInput?.surfaceProcessInputInfo?.map((paSurface) => {
            return {
              ...paSurface,
              areaUnitPrice: parseFloat(toDecimal(totalArea, 2)),
              weightUnitPrice: parseFloat(toDecimal(totalWeight, 2)),

              areaAutoExtract: parseFloat(toDecimal(totalArea, 2)),
              weightAutoExtract: parseFloat(toDecimal(totalWeight, 2)),
              totalArea: parseFloat(toDecimal(totalArea * paSurface?.areaCount, 2)),
              totalWeight: parseFloat(toDecimal(totalWeight * paSurface?.weightCount, 2)),
            };
          });
        props.selectedEstimateData.estimateProducts.processInput.surfaceProcessInputInfo = parentSurfaceData;
      }
    }
  };

  // 上方向ボタンの押下
  const upRowSelect = () => {
    let tempIQ3List = [...iQ3DataLst];
    let no = selectedData?.no - 1;
    let record = tempIQ3List?.filter((item) => item.no === no);
    if (record && record?.length > 0) {
      setCurrentRecordNo(record[0]?.no);
      setSelectedData(record[0]);
      scrollTo(record[0]?.no);
    }
  };

  // 下方向ボタンの押下
  const downRowSelect = () => {
    let tempIQ3List = [...iQ3DataLst];
    let no = selectedData?.no + 1;
    let record = tempIQ3List?.filter((item) => item.no === no);
    if (record && record?.length > 0) {
      setCurrentRecordNo(record[0]?.no);
      setSelectedData(record[0]);
      scrollTo(record[0]?.no);
    }
  };

  //　追加呼出ボタンの押下
  const displayAddParentInfo = async () => {
    let newParameters = await GetParametersByCompId();
    newParameters.estimateStatus = newParameters?.estimateStatus?.filter((item) => item.info.isUsed);
    newParameters.staff = newParameters?.staff?.filter((item) => item.info.isUsed);
    newParameters.client = newParameters?.client?.filter((item) => item.info.isUsed);
    setNewParameters(newParameters);
    setParentListDisplay(true);
    setIq3Loading(true); // Waitingダイアログを表示にする
  };

  // 2025-09-16 IQX_WEBEST-418 複数子部品の呼び出しは行えないか？
  const [selectedRowsFromChild, setSelectedRowsFromChild] = useState([]);

  const addPartFromParentInfoOk = async (selectedRows) => {
    if (!selectedRows || selectedRows.length === 0) {
      message.warning('データを選択してください');
      return;
    }

    props?.loading(true);
    setParentListDisplay(false);

    let addNewIQ3Lst = [];

    let lastRecord = iQ3DataLst?.length > 0 ? iQ3DataLst[iQ3DataLst.length - 1] : null;
    let no = lastRecord ? lastRecord.no + 1 : 1;

    for (let row of selectedRows) {
      if (row?.estimateProducts?.id) {
        let estimateProductId = row.estimateProducts.id;
        const addIQ3Lst = await getEstimateIQ3Data(estimateProductId);

        // 2025-10-06 IQX_WEBEST-466 DXF読み込み機能追加 (親部品リストから再び開くとサムネイルが表示されない)
        await fetchDataWithImages(addIQ3Lst);

        for (let i = 0; i < addIQ3Lst.length; i++) {
          var iq3Data = { ...addIQ3Lst[i] };
          iq3Data.id = 0;
          iq3Data.no = no;
          addNewIQ3Lst.push(iq3Data);
          no++;
        }
      }
    }

    setIQ3DataLst([...iQ3DataLst, ...addNewIQ3Lst]);
    setSelectedEstimateData({
      ...selectedEstimateData,
      esIq3Info: [...(selectedEstimateData?.esIq3Info ?? []), ...addNewIQ3Lst],
    });

    if (props.selectedEstimateData?.esIq3Info) {
      props.selectedEstimateData.esIq3Info = [...props.selectedEstimateData.esIq3Info, ...addNewIQ3Lst];
    }

    props?.loading(false);

    // recalc
    calculateChildPartCount();
    calculateWeightAreaForPaSurface();
    setReCalByAddDelete(true);
    props.updateIsRecal(true);
  };

  // 追加呼出ダイアログのOKボタン押下
  // const addPartFromParentInfoOk = async () => {
  //   props?.loading(true); // Waitingダイアログを表示にする
  //   setParentListDisplay(false);
  //   if (selectedParentAddEstimate !== undefined && selectedParentAddEstimate?.estimateProducts?.id) {
  //     let estimateProductId = selectedParentAddEstimate?.estimateProducts?.id;
  //     const addIQ3Lst = await getEstimateIQ3Data(estimateProductId);
  //     var lastRecord = iQ3DataLst?.length > 0 ? iQ3DataLst[iQ3DataLst?.length - 1] : [];
  //     let no = lastRecord != [] ? lastRecord?.no + 1 : 1;
  //     const addNewIQ3Lst = [];
  //     for (let i = 0; i < addIQ3Lst?.length; i++) {
  //       var iq3Data = { ...addIQ3Lst[i] };
  //       iq3Data.id = 0;
  //       iq3Data.no = no;
  //       addNewIQ3Lst.push(iq3Data);
  //       no++;
  //     }
  //     setIQ3DataLst([...iQ3DataLst, ...addNewIQ3Lst]);
  //     setSelectedEstimateData({
  //       ...selectedEstimateData,
  //       esIq3Info: [...selectedEstimateData?.esIq3Info, ...addNewIQ3Lst],
  //     });
  //     if (props.selectedEstimateData.esIq3Info) {
  //       props.selectedEstimateData.esIq3Info = [...props.selectedEstimateData.esIq3Info, ...addNewIQ3Lst];
  //     }
  //   }
  //   props?.loading(false); // Waitingダイアログを非表示にする
  //   // IQX_WEBEST-179
  //   calculateChildPartCount();
  //   calculateWeightAreaForPaSurface();
  //   //部品呼出追加より再計算
  //   setReCalByAddDelete(true);
  //   props.updateIsRecal(true);
  // };

  // 追加呼出ダイアログのCancelボタン押下
  const addPartFromParentInfoCancel = () => {
    setParentListDisplay(false);
  };

  // 追加呼出画面に行を選択した場合、
  const getSelectedEstimateData = (estimateData, iq3RowKey, estimateEditMode) => {
    setSelectedParentAddEstimate(estimateData);
  };

  // タブの切り替え
  const onChange = (key) => {
    setSelectedTabKey(key);
    onChangeTab(key);
    props?.updateIq3ActiveTabKey(key);
  };

  // タブの切り替え
  const onChangeTab = (key) => {
    setActiveTabKey(key);
    if (key === '1') {
      setMdalTitleTxt('パーツ情報');
      setDetailTabModalWidth(1290);
    } else if (key === '2') {
      setMdalTitleTxt('工程選択');
      setDetailTabModalWidth(1200);

      const curRowNo = currentRecordNo || 1;
      // 工程選択タブが表示された場合、現在選択中の行番号（currentRecordNo）を元に、props.selectedEstimateData.esIq3Info の中から該当するデータを探す。
      const matchingInfo = props.selectedEstimateData?.esIq3Info?.find((info) => info?.no === curRowNo);
      if (matchingInfo?.processSelect) {
        // 該当データに processSelect が存在すれば、その内容をディープコピーする
        const copiedProcessSelect = JSON.parse(JSON.stringify(matchingInfo.processSelect));
        // tempProcessSelect にセットする。
        setTempProcessSelect(copiedProcessSelect);
      } else {
        // 存在しない場合は null をセットする。
        setTempProcessSelect(null);
      }
    } else if (key === '3') {
      setMdalTitleTxt('工程入力');
      setDetailTabModalWidth(1390);
    } else if (key === '4') {
      // 2025-09-04 IQX_WEBEST-469 表記の統一
      setMdalTitleTxt('工程別積算');
      setDetailTabModalWidth(1370);
    } else if (key === '5') {
      setMdalTitleTxt('購入品');
      setDetailTabModalWidth(1300);
    } else if (key === '6') {
      setMdalTitleTxt('材料詳細');
      setDetailTabModalWidth(1300);
    } else if (key === '7') {
      setMdalTitleTxt('計算式');
      setDetailTabModalWidth(1300);
    }
  };

  const settingOK = () => {
    setIsSetting(false);
  };
  const settingCancel = () => {
    setIsSetting(false);
  };

  // 材料詳細の最初として入るかの判断を更新する
  const updateFirstTimeMaterialDetail = (value) => {
    setIsFirstTimeMaterialDetail(value);
  };

  const updateCurIQ3MaterialDetailData = (iq3) => {
    if (iq3?.no === selectedData?.no) {
      selectedData.thickness = iq3.thickness;
      selectedData.materialIq3Id = iq3.materialIq3Id;
      selectedData.materialName = iq3.materialName;
      selectedData.materialSurfaceIq3Id = iq3.materialSurfaceIq3Id;
      selectedData.materialSurfaceName = iq3.materialSurfaceName;
      selectedData.materialDetailSizes = iq3.materialDetailSizes;
      selectedData.materialDetailPatterns = iq3.materialDetailPatterns;
      selectedData.materialTypeName = iq3.materialTypeName;
      selectedData.materialTypeIq3Id = iq3.materialTypeIq3Id;
      selectedData.materialCostUnitPrice = iq3.materialCostUnitPrice; // 材料原価
      selectedData.materialCostTotalPrice = iq3.materialCostTotalPrice; // 材料原価合計
      selectedData.grabbingX = selectedData.grabbingX;
      selectedData.grabbingY = selectedData.grabbingY;
      selectedData.pierWidthX = selectedData.pierWidthX;
      selectedData.pierWidthY = selectedData.pierWidthY;
    }
  };

  const updateIq3PMXDatas = (value) => {
    setIq3PMXDatas(value);
    setCurrentRecordNoPMX(1);
  };

  // 基本情報タブのOKボタン押下
  const detailDialogOk = () => {
    // 2025-05-27 工程入力で何かしら数値や項目を変更した後、部品リストに変更したことがわかるように表示がほしい。
    if (selectedData?.isChangedProcessInput === false && hasProcessInputChanged) {
      selectedData.isChangedProcessInput = true;
      setIQ3DataLst((prev) =>
        prev.map((item) => (item.no === selectedData.no ? { ...item, isChangedProcessInput: true } : item))
      );
    }
    setIsDialogOk(true);
    setActiveTabKey('0');
    if (activeTabKey === '2') {
      if (selectedData && Object.keys(selectedProcessSelect)?.length > 0) {
        selectedData.processSelect = selectedProcessSelect;
        // 工程選択を変更した時、材料詳細も計算する
        isReCalMaterial(true);
      }
    }
    props.updateIsRecal(true);
    // 2025-05-27 工程入力で何かしら数値や項目を変更した後、部品リストに変更したことがわかるように表示がほしい。
    setHasProcessInputChanged(false);
    setTempProcessSelect(null);
  };

  // 基本情報タブのCancelボタン押下
  const detailDialogCancel = () => {
    // 工程選択タブ（activeTabKey === '2'）の場合、
    if (activeTabKey === '2') {
      const curRowNo = currentRecordNo || 1;
      // 現在選択されている行（currentRecordNo）に該当する esIq3Info を検索し、
      const targetIndex = props.selectedEstimateData?.esIq3Info?.findIndex((item) => item.no === curRowNo);

      if (targetIndex !== -1 && tempProcessSelect) {
        // 一時保存されている processSelect（tempProcessSelect）で上書きして元に戻す。
        props.selectedEstimateData.esIq3Info[targetIndex].processSelect = tempProcessSelect;
      }
      // 一時データをクリア
      setTempProcessSelect(null);
    }

    setIsDialogOk(false);
    setActiveTabKey('0');
  };

  // 追加子部品数Modalを表示する
  // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
  const requestRecordnoForAddAndCopy = async (key) => {
    setRecordAddOrCopy(key);
    if (props?.companySettingInfo?.[0]?.environments?.isAddMultipleChildParts) {
      setVisibleRecordNum(true);
    } else {
      if (key === '1') {
        addPart();
      } else {
        addCopyPart();
      }
    }
  };

  // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
  const handleRecordNumSelectChange = (value) => {
    // setSelectedValue(value);
    setRecordNum(value);
    setInputValue('');
  };

  // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
  const handleRecordNumInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setRecordNum(value);
    setSelectedValue(value);
  };

  // 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」
  const handleRecordNumBlur = () => {
    if (!inputValue && !recordNum) {
      setSelectedValue('1');
      setRecordNum(value);
    }
  };

  // 追加子部品数
  const requestRecordNumContent = (
    <div>
      <Select
        style={{ width: 180 }}
        value={inputValue || recordNum}
        onChange={handleRecordNumSelectChange}
        showSearch
        onBlur={handleRecordNumBlur}
        dropdownRender={(menu) => (
          <div>
            {menu}
            <div style={{ padding: 8 }}>
              <Input
                value={inputValue}
                onChange={handleRecordNumInputChange}
                onBlur={handleRecordNumBlur}
                placeholder="入力してください"
              />
            </div>
          </div>
        )}
        options={[
          {
            value: 1,
            label: '1',
          },
          {
            value: 2,
            label: '2',
          },
          {
            value: 3,
            label: '3',
          },
          {
            value: 4,
            label: '4',
          },
          {
            value: 5,
            label: '5',
          },
          {
            value: 6,
            label: '6',
          },
          {
            value: 7,
            label: '7',
          },
          {
            value: 8,
            label: '8',
          },
          {
            value: 9,
            label: '9',
          },
          {
            value: 10,
            label: '10',
          },
        ]}
      />

      <label style={{ fontSize: '13.5px', marginLeft: '10px' }}>部品追加</label>
    </div>
  );

  const requestOk = () => {
    setVisibleRecordNum(false);
    if (recordAddOrCopy === '1') {
      addPart();
    } else {
      addCopyPart();
    }

    // props.childEditMode(false);
  };

  const requestCancel = () => {
    setVisibleRecordNum(false);
    // props.childEditMode(false);
  };

  const menuIconList = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        height: '6%',
      }}
    >
      <Row style={{ marginTop: '0px', marginLeft: '0', width: '-webkit-fill-available' }}>
        <Col span={24}>
          <Space size="middle">
            <Tooltip title="部品追加" placement="bottom" overlayClassName="tooltip-text">
              <a
                onClick={() => {
                  // addPart();
                  requestRecordnoForAddAndCopy('1');
                }}
              >
                <Image preview={false} width={25} src={child_add} style={{ marginLeft: '5px' }}></Image>
              </a>
            </Tooltip>
            {/** IQX_WEBEST-311 板金子部品の「部品複写追加」機能の追加 */}
            <Tooltip title="部品複写追加" placement="bottom" overlayClassName="tooltip-text">
              <a
                onClick={() => {
                  // addCopyPart();
                  // 2025-09-11 IQX_WEBEST-468 正確に複写されないバグ
                  requestRecordnoForAddAndCopy('2');
                }}
              >
                <Image preview={false} width={25} src={copy_sm}></Image>
              </a>
            </Tooltip>
            <Tooltip title="部品削除" placement="bottom" overlayClassName="tooltip-text">
              <a
                onClick={() => {
                  deletePart();
                }}
              >
                <Image preview={false} width={23} src={child_delete} style={{ marginBottom: '1px' }}></Image>
              </a>
            </Tooltip>
            <Tooltip title="Up" placement="bottom" overlayClassName="tooltip-text">
              <a
                onClick={() => {
                  upRowSelect();
                }}
              >
                <Image
                  preview={false}
                  width={23}
                  src={up_Arrow}
                  style={{ marginLeft: '5px', marginBottom: '1px' }}
                ></Image>
              </a>
            </Tooltip>
            <Tooltip title="Down" placement="bottom" overlayClassName="tooltip-text">
              <a
                onClick={() => {
                  downRowSelect();
                }}
              >
                <Image
                  preview={false}
                  width={23}
                  src={down_Arrow}
                  style={{ marginLeft: '5px', marginBottom: '1px' }}
                ></Image>
              </a>
            </Tooltip>
            <Tooltip title="一括編集" placement="bottom" overlayClassName="tooltip-text">
              <a onClick={props?.updateAll}>
                <Image preview={false} width={25} src={edit_list} style={{ marginLeft: '5px' }}></Image>
              </a>
            </Tooltip>
            <Tooltip title="追加呼出" placement="bottom" overlayClassName="tooltip-text">
              <a onClick={displayAddParentInfo}>
                <Image preview={false} width={25} src={parent_call_detail} style={{ marginLeft: '5px' }}></Image>
              </a>
            </Tooltip>
            <div className="iq3-detail-btn-div">
              <Button
                className={activeTabKey == '1' ? 'iq3-detail-btn-active' : 'iq3-detail-btn'}
                onClick={(e) => {
                  onChange('1');
                }}
              >
                <FileExclamationOutlined style={{ fontSize: '23px' }} />
                <label style={{ color: activeTabKey == '1' ? 'white' : '#4a4747', fontWeight: 'bold' }}>
                  {/* 2025-05-14 子部品⇒子部品情報　または　パーツ情報　など */}
                  パーツ情報
                </label>
              </Button>
            </div>

            <div className="iq3-detail-btn-div">
              <Button
                className={activeTabKey == '2' ? 'iq3-detail-btn-active' : 'iq3-detail-btn'}
                onClick={(e) => {
                  onChange('2');
                }}
              >
                <FileDoneOutlined style={{ fontSize: '23px' }} />
                <label style={{ color: activeTabKey == '2' ? 'white' : '#4a4747', fontWeight: 'bold' }}>工程選択</label>
              </Button>
            </div>

            <div className="iq3-detail-btn-div">
              <Button
                className={activeTabKey == '3' ? 'iq3-detail-btn-active' : 'iq3-detail-btn'}
                onClick={(e) => {
                  onChange('3');
                }}
              >
                <FormOutlined style={{ fontSize: '23px' }} />
                <label style={{ color: activeTabKey == '3' ? 'white' : '#4a4747', fontWeight: 'bold' }}>工程入力</label>
              </Button>
            </div>
            <div className="iq3-detail-btn-div">
              <Button
                className={activeTabKey == '6' ? 'iq3-detail-btn-active' : 'iq3-detail-btn'}
                onClick={(e) => {
                  onChange('6');
                }}
              >
                <ProductOutlined style={{ fontSize: '23px' }} />
                <label style={{ color: activeTabKey == '6' ? 'white' : '#4a4747', fontWeight: 'bold' }}>材料詳細</label>
              </Button>
            </div>
            <div className="iq3-detail-btn-div">
              <Button
                className={activeTabKey == '4' ? 'iq3-detail-btn-active' : 'iq3-detail-btn'}
                onClick={(e) => {
                  onChange('4');
                }}
              >
                <MoneyCollectOutlined style={{ fontSize: '23px' }} />
                <label style={{ color: activeTabKey == '4' ? 'white' : '#4a4747', fontWeight: 'bold' }}>
                  {/* 2025-09-04 IQX_WEBEST-469 表記の統一 */}
                  工程別積算
                </label>
              </Button>
            </div>

            <div className="iq3-detail-btn-div">
              <Button
                className={activeTabKey == '5' ? 'iq3-detail-btn-active' : 'iq3-detail-btn'}
                onClick={(e) => {
                  onChange('5');
                }}
              >
                <ShoppingOutlined style={{ fontSize: '23px' }} />
                <label style={{ color: activeTabKey == '5' ? 'white' : '#4a4747', fontWeight: 'bold' }}>購入品</label>
              </Button>
            </div>

            {UserRoleToString[props?.loginUserInfo?.role] === UserRoleToString.Administrator && (
              <div className="iq3-detail-btn-div">
                <Button
                  className={activeTabKey == '7' ? 'iq3-detail-btn-active' : 'iq3-detail-btn'}
                  onClick={(e) => {
                    onChange('7');
                  }}
                >
                  <PayCircleOutlined style={{ fontSize: '23px' }} />
                  <label style={{ color: activeTabKey == '7' ? 'white' : '#4a4747', fontWeight: 'bold' }}>計算式</label>
                </Button>
              </div>
            )}
          </Space>
        </Col>
      </Row>
    </div>
  );

  const childPartListHeader = (
    <div
      style={{
        display: 'flex',
        height: 27,
      }}
    >
      <Space size="small">
        <p
          style={{
            fontSize: '13px',
            fontWeight: 'bold',
            margin: 0,
            paddingLeft: 7,
            color: 'black',
          }}
        >
          部品リスト：
        </p>
        <div style={{ display: 'flex', marginLeft: '0px', marginTop: '1.3px' }}>
          {' '}
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              margin: 0,
              paddingLeft: 3,
              paddingRight: 3,
              color: '#4A4747',
              border: 'solid',
              borderWidth: 0.5,
              borderColor: '#4A4747',
              backgroundColor: '#fcfade',
              borderRadius: 3,
            }}
          >
            選択中
          </p>
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              paddingLeft: 10,
              margin: 0,
              paddingRight: 10,
              color: 'black',
            }}
          >
            {selectedData != undefined && selectedData.no != undefined ? 'No.' + selectedData.no : 'No.0'}
          </p>
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              margin: 0,
              color: 'black',
            }}
          >
            /
          </p>
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              margin: 0,
              paddingLeft: 10,
              paddingRight: 10,
              color: 'black',
            }}
          >
            {selectedData != undefined ? selectedData.drawingNo : 0}
          </p>
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              margin: 0,
              color: 'black',
            }}
          >
            /
          </p>
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              margin: 0,
              paddingLeft: 10,
              paddingRight: 10,
              color: 'black',
            }}
          >
            {selectedData != undefined ? selectedData.name : 0}
          </p>
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              margin: 0,
              color: 'black',
            }}
          >
            /
          </p>
          <p
            style={{
              fontSize: '13px',
              fontWeight: '600',
              margin: 0,
              paddingLeft: 10,
              paddingRight: 10,
              color: 'black',
            }}
          >
            {selectedData != undefined ? selectedData.partCount : 0}
          </p>
        </div>
      </Space>
    </div>
  );

  const modalTitle = (
    <div
      style={{
        width: 400,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{modalTitleTxt}</p>
    </div>
  );

  const parentListModalTitle = (
    <div
      style={{
        width: 1670,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 33,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 5, paddingLeft: 18, color: 'white' }}>追加呼出</p>
    </div>
  );

  // iframe HTML を組み立てる
  const iframeHtml = `
        <!DOCTYPE html>
        <html lang="en">
          <head>
            <meta charset="UTF-8" />
            <link rel="stylesheet" href="/assets/at2-dsmcad/styles.css" />
            <title>CAD入力</title>
            <!-- CAD SIM WebComponent のスクリプトを読み込む -->
            <script src="/assets/at2-dsmcad/at2dsmcad.js"></script>
            <style>
              body { margin: 0; padding: 0; }
              iframe { border: none; width: 100%; height: 100%; }
            </style>
          </head>
          <body>
            <app-at2dsmcad id='at2dsmcad'/>
            <script>
              window.addEventListener('DOMContentLoaded', () => {
                const app = document.getElementById('at2dsmcad');
                app.BaseURL = '${process.env.REACT_APP_SM_CAD_API_URL}';
                app.CompanyID = '${simCadParamCompanyID}';
                app.UserID = '${simCadParamUserId}';
                app.ExternalAppID = '${SM_CAD_ExternalAppID}'
                app.ExternalAppURL = '${process.env.REACT_APP_FRONTEND_URL}';
                app.FeatureID = '${SM_CAD_FeatureID}';
              });
            </script>
          </body>
        </html>
      `;

  const iq3Columns = [
    {
      id: '1',
      title: 'No.',
      dataIndex: 'no',
      className: 'cm-a-right',
      width: '5%',
      render: (text, record) => (
        // 2025-05-27 工程入力で何かしら数値や項目を変更した後、部品リストに変更したことがわかるように表示がほしい。
        <span style={{ color: record?.isChangedProcessInput === false ? 'inherit' : 'red' }}>{text}</span>
      ),
    },
    {
      id: '2',
      title: '状態',
      dataIndex: 'creationType',
      // width: 80 + 'px',
      width: '5%',
      align: 'center',
      render: (value) =>
        value === EstimateCreationType.Auto ? (
          <Image src={auto} alt="" width={31} preview={false} />
        ) : (
          <Image src={manual} alt="" width={31} preview={false} />
        ),
    },
    {
      id: '3',
      title: '画像',
      dataIndex: 'imageUrl', // IQX_WEBEST-207
      // width: 180 + 'px',
      width: '12%',
      align: 'center',
      render: (value, index) => (
        <div>
          <div
            style={{
              backgroundColor: value && value != 'fail' ? '' : '#000000e0',
              cursor: 'pointer',
              height: value && value != 'fail' ? '' : 100,
              width: '100%',
            }}
            onClick={() => {
              setShowSMCadComponent(true);
            }}
          >
            <div id={'img-div' + index} className="img-div">
              {/* <img id={'img' + index} className="img" src={value ? value : ''} alt="thumbnail" /> */}
              {/* 2025-09-30 IQX_WEBEST-466 DXF読み込み機能追加 */}
              {value && value != 'fail' ? (
                <img
                  id={'img' + index}
                  className="img"
                  src={value}
                  alt="thumbnail"
                  style={{
                    width: '100%',
                    height: 'auto',
                    maxHeight: '100%',
                    objectFit: 'contain',
                  }}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
        // <img

        //   className={value === undefined || value === '' ? 'pmx-no-img' : 'pmx-img'}
        //   src={value}
        //   alt=""
        // />
      ), // IQX_WEBEST-247
    },
    {
      id: '4',
      // title: ['工程パターン', ' / ', '子部品図番', ' / ', '子部品名称'],
      title: (
        <div style={{ textAlign: 'center' }}>
          <div>工程パターン</div>
          <div>子部品図番</div>
          <div>子部品名称</div>
        </div>
      ),
      dataIndex: 'drawingNoName',
      // width: 280 + 'px',
      width: '14%',
      align: 'center',
      render: (_, record, index) => (
        <div style={{ textAlign: 'left' }}>
          {/* <label style={{ fontSize: '13px' }}>{record?.processSelect?.name}</label> */}
          <Typography.Text
            id={'typographyTxt'}
            style={{ fontSize: '13px' }}
            ellipsis={{ tooltip: [record?.processSelect?.name] }}
          >
            {record?.processSelect?.name}
          </Typography.Text>
          <br />
          <Input
            style={{
              fontSize: '13px',
              height: 25,
              padding: 3,
              borderColor: '#a5a5a563',
              borderRadius: 4,
              marginTop: 8,
            }}
            className="input-editable"
            name="drawingNo"
            value={record.drawingNo}
            onChange={(e) => {
              if (record.drawingNo !== e.target.value) {
                let tempIQ3List = [...iQ3DataLst];
                tempIQ3List[index].drawingNo = e.target.value;
                setIQ3DataLst(tempIQ3List);
                props.selectedEstimateData.esIq3Info = tempIQ3List;
              }
            }}
          />
          <br />
          <Input
            style={{
              fontSize: '13px',
              height: 25,
              padding: 3,
              borderColor: '#a5a5a563',
              borderRadius: 4,
              marginTop: 8,
            }}
            className="input-editable"
            name="name"
            value={record.name}
            onChange={(e) => {
              if (record.name !== e.target.value) {
                let tempIQ3List = [...iQ3DataLst];
                tempIQ3List[index].name = e.target.value;
                setIQ3DataLst(tempIQ3List);
                props.selectedEstimateData.esIq3Info = tempIQ3List;
              }
            }}
          />
          <br />
        </div>
      ),
    },
    {
      id: '5',
      title: (
        <div style={{ textAlign: 'center' }}>
          <div>員数</div>
          <div>(製造数)</div>
        </div>
      ),
      dataIndex: 'partCount',
      // width: 150 + 'px',
      width: '5%',
      align: 'center',
      render: (_, record, index) => (
        <div style={{ textAlign: 'center' }}>
          <Input
            style={{
              textAlign: 'center',
              width: 50,
              fontSize: '13px',
              height: 25,
              padding: 3,
              borderColor: '#a5a5a563',
              borderRadius: 4,
            }}
            className="input-editable"
            name="partCount"
            value={record.partCount}
            onChange={(e) => {
              if (record.partCount !== e.target.value) {
                let tempIQ3List = [...iQ3DataLst];
                tempIQ3List[index].partCount = e.target.value;
                setIQ3DataLst(tempIQ3List);
                setIsPartCountChange(true);
              }
            }}
            onBlur={(e) => {
              // 員数はフォーカス離す、タブを離れることで自動計算される。
              if (isPartCountChange) {
                setIsPartCountChange(false);
                props.selectedEstimateData.esIq3Info[index].partCount = record.partCount;
                setIq3ActionForCal(true);
                props.updateIsRecal(true);
              }
            }}
            onPressEnter={(e) => {
              // 員数はEnterキーを押すことで自動計算される。
              if (isPartCountChange) {
                setIsPartCountChange(false);
                setIq3ActionForCal(true);
                props.updateIsRecal(true);
              }
            }}
          />
          <br />
          <label style={{ fontSize: '13px', marginLeft: 5, marginTop: 8 }}>
            {'(' + record.partCount * props?.selectedEstimateData?.estimateProducts?.quantity + ')'}
          </label>
        </div>
      ),
    },
    {
      id: '6',
      // title: ['材質', ' / ', '板厚', ' / ', '表面保護'],
      title: (
        <div style={{ textAlign: 'center' }}>
          <div>材質 / 板厚</div>
          <div>表面保護</div>
        </div>
      ),
      dataIndex: 'materialItems',
      // width: 200 + 'px',
      width: '12%',
      align: 'center',
      render: (_, record, index) =>
        // 2025-07-01 IQX_WEBEST-431 表記の仕方を変更してほしい
        estimateParameters ? (
          <div>
            <div style={{ textAlign: 'center' }}>
              <Typography.Text
                id={'typographyTxt'}
                style={{ fontSize: '13px' }}
                ellipsis={{
                  tooltip: [getMaterialTypeById(record.materialTypeIq3Id, estimateParameters?.materialTypeIq3)],
                }}
              >
                {getMaterialTypeById(record.materialTypeIq3Id, estimateParameters?.materialTypeIq3)}-{' '}
                {getMaterialThickById(record?.thickness, estimateParameters?.materialIq3)}
              </Typography.Text>
            </div>
            <div>
              <Select
                className="iq3-detail-select"
                name="materialSurfaceIq3Id"
                value={record.materialTypeIq3Id ?? null}
                onChange={(value) => {
                  if (record.materialTypeIq3Id !== value) {
                    // 選択された材質に当てはまる材料情報を取得
                    let materialList = materialLstSelect?.filter(
                      (item) => item.info.isUsed && item.materialTypeIq3Id == value
                    );
                    if (materialList?.length > 0) {
                      let materialId = materialList[0]?.id;
                      filteredInfoByMaterialType(value, materialId, index);
                      setIq3ActionForCal(true);
                      props.updateIsRecal(true);
                    }
                  }
                }}
                style={{ marginLeft: 5, width: '98.2%', textAlign: 'left' }}
              >
                {materialTypeLstSelect
                  ?.filter((item) => materialLstSelect?.findIndex((mItem) => mItem.materialTypeIq3Id === item.id) > -1)
                  ?.map((option, index) => (
                    <Select.Option key={index} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
              </Select>
            </div>
            <div>
              <Select
                className="iq3-detail-select"
                name="materialSurfaceIq3Id"
                value={record.thickness ?? null}
                onChange={(value) => {
                  if (record.thickness !== value) {
                    // 選択された板厚（板厚は材料のIDで制御しているため）に当てはまる材料情報を取得
                    let materialList = materialLstSelect?.filter((item) => item.info.isUsed && item.id == value);
                    if (materialList?.length > 0) {
                      let materialTypeId = materialList[0]?.materialTypeIq3Id;
                      filteredInfoByMaterialType(materialTypeId, value, index);
                      setIq3ActionForCal(true);
                      props.updateIsRecal(true);
                    }
                  }
                }}
                style={{ marginLeft: 5, width: '98.2%', textAlign: 'left' }}
              >
                {materialLstSelect
                  ?.filter((item) => item.info?.isUsed && item.materialTypeIq3Id === record?.materialTypeIq3Id)
                  ?.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {Number(option.info.thick).toFixed(1)}
                    </Select.Option>
                  ))}
              </Select>
            </div>
            <div>
              <Select
                className="iq3-detail-select"
                name="materialSurfaceIq3Id"
                value={record.materialSurfaceIq3Id ?? null}
                onChange={(value) => {
                  if (record.materialSurfaceIq3Id !== value) {
                    let tempIQ3List = [...iQ3DataLst];

                    tempIQ3List[index].materialSurfaceIq3Id = value;
                    tempIQ3List[index].materialSurfaceName = getMaterialSurfaceById(value, materialSurfaceLstSelect);

                    setIQ3DataLst(tempIQ3List);
                    props.selectedEstimateData.esIq3Info[index].materialSurfaceIq3Id = value;
                    props.selectedEstimateData.esIq3Info[index].materialSurfaceName =
                      tempIQ3List[index].materialSurfaceName;

                    setIq3ActionForCal(true);
                    props.updateIsRecal(true);
                  }
                }}
                style={{ marginLeft: 5, width: '98.2%', textAlign: 'left' }}
              >
                {materialSurfaceLstSelect
                  ?.filter((item) => item.info?.isUsed && item.materialTypeIq3Id === record?.materialTypeIq3Id)
                  ?.map((option) => (
                    <Select.Option key={option.id} value={option.id}>
                      {option.name}
                    </Select.Option>
                  ))}
              </Select>
            </div>
          </div>
        ) : (
          <></>
        ),
    },
    {
      id: '7',
      title: (
        <div style={{ textAlign: 'center' }}>
          <div>重量</div>
          <div>面積</div>
        </div>
      ),
      dataIndex: 'amountItems',
      // width: 200 + 'px',
      width: '8%',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.weight ? toDecimal(record.weight, 2) : toDecimal(0, 2)}
            kg
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.totalSurfaceArea != undefined ? toDecimal(record.totalSurfaceArea, 2) : toDecimal(0, 2)}
            cm<sup>2</sup>
          </label>
        </div>
      ),
    },
    {
      id: '8',
      // title: ['材料', ' / ', '製造', ' / ', '購入品'],
      title: (
        <div style={{ textAlign: 'center' }}>
          <div>材料</div>
          {/* 2025-09-04 IQX_WEBEST-469 表記の統一 */}
          <div>製造原価</div>
          <div>表面処理費</div>
        </div>
      ),
      dataIndex: 'amountItems',
      // width: 200 + 'px',
      width: '10%',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.materialCostUnitPrice ? JPYs.format(Math.round(record.materialCostUnitPrice)) : amtEmptyStr}
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.workCostUnitPrice ? JPYs.format(Math.round(record.workCostUnitPrice)) : amtEmptyStr}
          </label>
          <br />
          <label style={{ fontSize: '13px', marginTop: 8 }}>
            {record.surfaceUnitPrice ? JPYs.format(Math.round(record.surfaceUnitPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '9',
      title: '原価',
      dataIndex: 'costUnitPrice',
      // width: 200 + 'px',
      width: '10%',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.costUnitPrice ? JPYs.format(Math.round(record.costUnitPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '10',
      title: '原価合計',
      dataIndex: 'costTotalPrice',
      // width: 200 + 'px',
      width: '10%',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.costTotalPrice ? JPYs.format(Math.round(record.costTotalPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
    {
      id: '11',
      title: '購入品',
      dataIndex: 'purchaseUnitPrice',
      width: '8%',
      align: 'center',
      render: (_, record) => (
        <div style={{ textAlign: 'right' }}>
          <label style={{ fontSize: '13px' }}>
            {record.purchaseUnitPrice ? JPYs.format(Math.round(record.purchaseUnitPrice)) : amtEmptyStr}
          </label>
        </div>
      ),
    },
  ];

  const settingModalTitle = (
    <div
      style={{
        width: 450,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
        display: 'flex',
      }}
    >
      <p style={{ marginLeft: 7, paddingTop: 8, color: 'white' }}>設定</p>
    </div>
  );

  // 設定コンテンツ
  const settingContent = (
    <>
      <Row style={{ marginTop: '0px' }}>
        <Col span={2}>
          <Checkbox checked></Checkbox>
        </Col>
        <Col span={22}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>空送線を見積計算に含める</p>
        </Col>
      </Row>
      <Row style={{ marginTop: '0px' }}>
        <Col span={2}>
          <Checkbox checked></Checkbox>
        </Col>
        <Col span={22}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>プランク加工の下穴を見積計算に含める</p>
        </Col>
      </Row>
      <Row style={{ marginTop: '0px' }}>
        <Col span={2}>
          <Checkbox checked></Checkbox>
        </Col>
        <Col span={22}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>外形線を1本化処理して計算する</p>
        </Col>
      </Row>
      <Row style={{ marginTop: '0px' }}>
        <Col span={2}>
          <Checkbox checked></Checkbox>
        </Col>
        <Col span={22}>
          <p style={{ fontSize: '13.5px', fontWeight: '500', margin: 0 }}>同一線上の曲げ線をまとめる</p>
        </Col>
      </Row>
      <Row style={{ marginTop: '15px' }}>
        <Col span={24} style={{ textAlign: 'right' }} offset={0}>
          <Button onClick={settingOK} className="mainButton" id="update">
            OK
          </Button>

          <Button onClick={settingCancel} className="cancelButton" style={{ marginLeft: 10 }} id="discard">
            キャンセル
          </Button>
        </Col>
      </Row>
    </>
  );

  const detailModalTitle = (
    <div
      style={{
        width: detailTabModalWidth,
        backgroundColor: '#005fab',
        marginLeft: -24,
        height: 36,
        marginTop: -20,
        borderTopLeftRadius: 7,
        borderTopRightRadius: 7,
        fontSize: 14,
      }}
    >
      <p style={{ paddingTop: 8, paddingLeft: 18, color: 'white' }}>{modalTitleTxt}</p>
    </div>
  );
  const onCancel = () => {
    setShowSMCadComponent(false);
  };
  const calSimCancel = () => {
    setConfirmCalCadSim(false);
  };

  // ブランクの種類.形状により、データ設定
  const getSize = (id, size) => {
    return id === 3 || id === 4 ? toDecimal(size || 0, 2) : toDecimal(0, 2);
  };
  const getDiameter = (id, xl) => {
    return id <= 2 ? toDecimal(parseFloat(xl) || 0, 2) : toDecimal(0, 2);
  };

  const calSimCADPMXData = () => {
    const baseURL = process.env.REACT_APP_SM_CAD_API_URL;

    var userContext = new AppUserContext();
    userContext.FeatureID = SM_CAD_FeatureID;
    userContext.CompanyID = simCadParamCompanyID;
    userContext.UserID = simCadParamUserId;

    const encodedUserContext = encodeURIComponent(JSON.stringify(userContext));

    const pmxFileStringURL = `${baseURL}/api/PMXFile/GetPMXFileURL/?userContext=${encodedUserContext}`;
    fetch(pmxFileStringURL)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then(async (data) => {
        console.log('PMX File String:', data);
        setCurPmxInfo(data);
        localStorage.setItem('iQxWeb_cur_pmx', encodeURI(JSON.stringify(data)));
        setConfirmCalCadSim(true);
      })
      .catch((err) => {
        console.error('Error fetching PMX file string:', err);
      });
  };

  const calSimCAD = async () => {
    setConfirmCalCadSim(false);
    console.log('Cur PMX File:', curPMXInfo);
    const blob = new Blob([curPMXInfo], { type: 'application/octet-stream' });
    const base64String = await blobToBase64(blob);
    const pmxFormData = new FormData();
    pmxFormData.append('cad3dId', 1);
    pmxFormData.append('pmxBase64String', base64String);
    pmxFormData.append('fileName', file.name);

    const pmxUrl = `${process.env.REACT_APP_BACKEND_API_URL}Card/GetPMXFileData`;

    const pmxDataResponse = await axios.post(pmxUrl, pmxFormData, {
      headers: {
        Authorization: 'Bearer ' + getAccessToken(),
        'X-ZF-APP-KEY': process.env.REACT_APP_API_KEY_AUTH,
      },
    });

    let selectedCardData = pmxDataResponse?.data?.data;
    let curIq3Info = selectedData;
    let processMst = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.process;
    let bendingTypes = [];
    let weldingTypes = [];
    let subWeldingTypes = [];
    let secWorkTypes = [];
    const bendingDetails = processMst?.filter((i) => i.workType === WorkType.SmBending);
    if (bendingDetails?.length > 0) {
      bendingTypes = bendingDetails[0]?.details?.processDetailTypes?.filter((i) => i.isUsed);
    }
    const weldingDetails = processMst?.filter((i) => i.workType === WorkType.SmWelding);
    if (weldingDetails?.length > 0) {
      weldingTypes = weldingDetails[0].details?.processDetailTypes?.filter(
        (i) => i.group === WorkTypeGroup.SmWelding && i.isUsed
      );

      subWeldingTypes = weldingDetails[0].details?.processDetailTypes?.filter(
        (i) => (i.group === WorkTypeGroup.SmInstSize && i.isUsed) || (i.group === WorkTypeGroup.SmInstThick && i.isUsed)
      );
    }
    const secWorkDetails = processMst?.filter((i) => i.workType === WorkType.SmSecondaryWork);
    if (secWorkDetails?.length > 0) {
      secWorkTypes = secWorkDetails[0].details?.processDetailTypes?.filter(
        (i) =>
          (i.group === WorkTypeGroup.SmSecondaryWorkSize && i.isUsed) ||
          (i.group === WorkTypeGroup.SmSecondaryWorkMillimeter && i.isUsed)
      );
    }
    // IQX_WEBEST-272 PMX取込時にPMXの付加情報を見積に反映させてほしい
    const customerInfo = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.client;

    let cardMainDataDetails = selectedCardData?.details?.[0];
    let cardDetails = cardMainDataDetails?.processingInfo ? JSON.parse(cardMainDataDetails?.processingInfo) : {};

    // 基本情報設定
    // if (cardMainDataDetails?.thumbPath !== undefined) {
    //   let iq3PmxImg = await getCardDetailImg(cardMainDataDetails?.id);
    //   if (iq3PmxImg !== undefined) {
    //     // IQX_WEBEST-207
    //     curIq3Info.imageId = cardMainDataDetails?.id
    //       ? (cardMainDataDetails?.id).toString()
    //       : '';
    //     curIq3Info['imageUrl'] = URL.createObjectURL(iq3PmxImg);
    //   } else {
    //     curIq3Info.imageId = '';
    //   }
    // }

    if (cardDetails?.contourLength?.outerCadItems !== undefined) {
      let outerCadItems = cardDetails?.contourLength?.outerCadItems;
      curIq3Info['outerCadItems'] = outerCadItems;
    }

    curIq3Info.partCount = cardMainDataDetails?.quantity;
    curIq3Info.drawingNo = cardMainDataDetails?.drawingNo;
    curIq3Info.name = cardMainDataDetails?.name;
    const __pmxRaw = ((cardMainDataDetails && (cardMainDataDetails.material ?? cardMainDataDetails.Material)) || '').trim();
    let __hasMaterialTypeMap = false;
    if (__pmxRaw) {
      
      const m = __pmxRaw.match(/^[^_]*_(.+)$/);
      const key = m ? m[1].trim() : null;
      if (m) {
        const mtList = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.materialTypeIq3;
        const mt = mtList?.find((t) => (t.name || '').trim() === key);
        if (mt) {
          curIq3Info.materialTypeIq3Id = mt.id;
          curIq3Info.materialTypeName = mt.name;
          __hasMaterialTypeMap = true;
        } else {
          
        }
      }
    }
    let pmxThickness = cardDetails?.thickness;
    // 材料リスト
    let materialList = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.materialIq3;
    let materialSurfaceLst = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.materialSurfaceIq3;
    let materialNm = materialList?.filter((item) => item.info?.thick === pmxThickness && item.info.isUsed);

    let materialTypeList = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.materialTypeIq3;
    let materialSurfaceList = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.materialSurfaceIq3;
    let gravity = 0.0;
    const g = materialList?.find((item) => item.materialTypeIq3Id === curIq3Info.materialTypeIq3Id);
    gravity = g?.info?.gravity ?? 0.0;

    //　面積・重量設定
    //重量(kg) = 板厚(mm) X Xサイズ(mm) X Yサイズ(mm) ÷ 1000000 X 比重(g/㎤)
    let sizeX = cardDetails?.boundaryBoxSize?.width
      ? toDecimal(cardDetails?.boundaryBoxSize?.width, 2)
      : toDecimal(0, 2);
    let sizeY = cardDetails?.boundaryBoxSize?.height
      ? toDecimal(cardDetails?.boundaryBoxSize?.height, 2)
      : toDecimal(0, 2);

    const thicknessInfo = materialList?.find((item) => item.materialTypeIq3Id === curIq3Info?.materialTypeIq3Id);
    let thicknessVal = 0;
    if (thicknessInfo != undefined) {
      thicknessVal = parseFloat(thicknessInfo?.info?.thick);
    }
    let weight = ((thicknessVal * parseInt(sizeX) * parseInt(sizeY)) / 1000000) * gravity;
    let reCalArea = Number.isFinite((sizeX * sizeY) / 100) ? (sizeX * sizeY) / 100 : toDecimal(0, 2);
    // IQX_WEBEST-84(Cardの面積(mm)をcmに変換)
    let cardDetailsArea = Number.isFinite(cardDetails?.area / 100) ? cardDetails?.area / 100 : reCalArea;
    cardDetailsArea = cardDetailsArea ? toDecimal(cardDetailsArea, 2) : toDecimal(0, 2);

    curIq3Info.partSizeX = sizeX;
    curIq3Info.partSizeY = sizeY;
    curIq3Info.totalSurfaceArea = cardDetailsArea;
    if (sizeX && sizeY && weight) {
      curIq3Info.weight = Number.isFinite(weight) ? weight : toDecimal(0, 2);
    }

    //板金子部品より親部品の重量と面積データ更新
    if (curIq3Info?.weight) {
      selectedEstimateData.estimateProducts.totalWeight += curIq3Info?.weight ? curIq3Info?.weight : 0;
    }
    if (curIq3Info?.totalSurfaceArea) {
      selectedEstimateData.estimateProducts.totalSurfaceArea += curIq3Info?.totalSurfaceArea
        ? Number(curIq3Info?.totalSurfaceArea)
        : 0.0;
    }

    // 会社環境設定情報取得
    const settingResponse = await getExistCompanySetting();
    let companySettingInfo = {};
    if (settingResponse && Object.keys(settingResponse)?.length > 0) {
      companySettingInfo = settingResponse;
    }

    //工程入力情報設定
    let updateProcessInputs = [];
    let processInputs = JSON.parse(JSON.stringify(curIq3Info?.processInput));
    for (let j = 0; j < processInputs?.length; j++) {
      let curWorkType = processMst?.filter((item) => item.id == processInputs[j].processId)?.[0]?.workType;
      // IQX_WEBEST-179
      processInputs[j].autoExtractXSize = sizeX ? Number(sizeX) : 0;
      processInputs[j].autoExtractYSize = sizeY ? Number(sizeY) : 0;
      if (curWorkType === WorkType.SmProgram) {
        let programProcessInput = processInputs[j];
        programProcessInput.details[0].elements = cardDetails?.elements;
        programProcessInput.details[0].elementsAuto = cardDetails?.elements; // IQX_WEBEST-179
        updateProcessInputs.push(programProcessInput);
      } else if (
        curWorkType === WorkType.SmBlankCombi ||
        curWorkType === WorkType.SmBlankLaser ||
        curWorkType === WorkType.SmBlankPunch
      ) {
        // 空送線計算有情報取得
        let isAirLineCalculationFlg = companySettingInfo?.[0]?.environments?.isAirLineCalculation;
        let blankProcessInput = processInputs[j];
        blankProcessInput.details[0].dimensionData.outerDia = cardDetails?.contourLength?.outerLength
          ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
          : toDecimal(0, 2);
        blankProcessInput.details[0].dimensionData.innerDia = cardDetails?.contourLength?.innerLength
          ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
          : toDecimal(0, 2);
        // 空送線計算有にチェックありの場合、空送線長で計算する
        if (isAirLineCalculationFlg) {
          blankProcessInput.details[0].dimensionData.airFeedDistance = cardDetails?.airDistance
            ? toDecimal(cardDetails?.airDistance, 2)
            : toDecimal(0, 2);
          blankProcessInput.details[0].dimensionData.airFeedAutoExtract = cardDetails?.airDistance
            ? toDecimal(cardDetails?.airDistance, 2)
            : toDecimal(0, 2);
        } else {
          // 空送線計算有にチェック無しの場合、空送線長で計算しない。
          blankProcessInput.details[0].dimensionData.airFeedDistance = toDecimal(0, 2);
          blankProcessInput.details[0].dimensionData.airFeedAutoExtract = toDecimal(0, 2);
        }
        blankProcessInput.details[0].dimensionData.etchingLength = cardDetails?.etchingLength
          ? toDecimal(cardDetails?.etchingLength, 2)
          : toDecimal(0, 2);
        // IQX_WEBEST-179
        blankProcessInput.details[0].dimensionData.outerAutoExtract = cardDetails?.contourLength?.outerLength
          ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
          : toDecimal(0, 2);
        blankProcessInput.details[0].dimensionData.innerAutoExtract = cardDetails?.contourLength?.innerLength
          ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
          : toDecimal(0, 2);

        let qtyLen = blankProcessInput.details[0].quantityList?.length;
        if (cardDetails?.contourLength?.holes?.length > 0) {
          blankProcessInput.details[0].quantityList.shift();
          for (let k = 0; k < cardDetails?.contourLength?.holes?.length; k++) {
            let typeId = Types?.filter((item) => item.value === 'その他')?.[0]?.id;
            let holdType = BlankTypes?.filter(
              (item) => item.value === cardDetails?.contourLength?.holes?.[k]?.name
            )?.[0]?.label;
            let blanktypes = Types?.filter((item) => item.value === holdType)?.[0];
            if (blanktypes) {
              typeId = blanktypes?.id;
            }
            const hold = cardDetails?.contourLength?.holes?.[k];
            const newListRow = {
              id: k + 1 + qtyLen,
              types: typeId,
              typesAutoExtract: typeId,
              diameter: getDiameter(typeId, hold?.xl),
              diameterAutoExtract: getDiameter(typeId, hold?.xl),
              xsize: getSize(typeId, hold?.xl),
              xsizeAutoExtract: getSize(typeId, hold?.xl),
              ysize: getSize(typeId, hold?.yl),
              ysizeAutoExtract: getSize(typeId, hold?.yl),
              perimeter: hold?.length && hold?.number ? toDecimal(hold?.length / hold?.number, 2) : toDecimal(0, 2),
              perimeterAutoExtract:
                hold?.length && hold?.number ? toDecimal(hold?.length / hold?.number, 2) : toDecimal(0, 2),
              count: hold?.number,
              countAutoExtract: hold?.number,
              combinedBorderLines: hold?.combinedBorderLines,
            };
            blankProcessInput.details[0].quantityList?.push(newListRow);
          }
        } else {
          blankProcessInput.details[0].quantityList[0].types = 1;
          blankProcessInput.details[0].quantityList[0].typesAutoExtract = 1;
          blankProcessInput.details[0].quantityList[0].diameter = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].diameterAutoExtract = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].xsize = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].xsizeAutoExtract = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].ysize = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].ysizeAutoExtract = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].perimeter = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].perimeterAutoExtract = toDecimal(0, 2);
          blankProcessInput.details[0].quantityList[0].count = 1;
          blankProcessInput.details[0].quantityList[0].countAutoExtract = 1;
          blankProcessInput.details[0].quantityList[0].combinedBorderLines = [];
        }
        updateProcessInputs.push(blankProcessInput);
      } else if (curWorkType === WorkType.SmBending) {
        let bendProcessInput = processInputs[j];
        const maxBendLength = cardDetails?.bendInfo
          ? cardDetails?.bendInfo?.reduce((max, item) => {
              return item.width > max ? item.width : max;
            }, 0)
          : 0; // IQX_WEBEST-84
        bendProcessInput.details[0].bendingData.maxBendLength = maxBendLength
          ? toDecimal(maxBendLength, 2)
          : toDecimal(0, 2);
        // IQX_WEBEST-179
        bendProcessInput.details[0].bendingData.maxBendAutoExtract = maxBendLength
          ? toDecimal(maxBendLength, 2)
          : toDecimal(0, 2);
        let bendLen = bendProcessInput.details[0].bendingList?.length;
        if (cardDetails?.bendInfo?.length > 0) {
          bendProcessInput?.details[0]?.bendingList?.shift();
          for (let k = 0; k < cardDetails?.bendInfo?.length; k++) {
            const bend = cardDetails?.bendInfo[k];

            let typeId = bendingTypes?.[0]?.id;

            let bendId = BendingTypes?.filter((itemType) => itemType.value === bend?.name)?.[0]?.id;
            let result = bendingTypes?.filter((subWeldItem) => subWeldItem.id === bendId)?.[0];

            if (result) {
              typeId = result?.id;
            }

            const newListRow = {
              id: k + 1 + bendLen,
              types: typeId,
              typesAutoExtract: typeId,
              bendLength: bend?.width ? toDecimal(bend?.width, 2) : toDecimal(0, 2),
              bendLengthAutoExtract: bend?.width ? toDecimal(bend?.width, 2) : toDecimal(0, 2),
              lines: bend?.number, // 曲げ回数（曲げ線数）// IQX_WEBEST-210
              linesAutoExtract: bend?.number, // 曲げ回数（曲げ線数）// IQX_WEBEST-210
              bendCount: bend?.name === FRBend ? bend?.amount : 1, // FR曲げ回数
              bendCountAutoExtract: bend?.name === FRBend ? bend?.amount : 1, // FR曲げ回数
            };
            bendProcessInput?.details[0]?.bendingList?.push(newListRow);
          }
        } else {
          bendProcessInput.details[0].bendingList[0].types = 1;
          bendProcessInput.details[0].bendingList[0].typesAutoExtract = 1;
          bendProcessInput.details[0].bendingList[0].bendLength = toDecimal(0, 2);
          bendProcessInput.details[0].bendingList[0].bendLengthAutoExtract = toDecimal(0, 2);
          bendProcessInput.details[0].bendingList[0].lines = 1;
          bendProcessInput.details[0].bendingList[0].linesAutoExtract = 1;
          bendProcessInput.details[0].bendingList[0].bendCount = 1;
          bendProcessInput.details[0].bendingList[0].bendCountAutoExtract = 1;
        }
        updateProcessInputs.push(bendProcessInput);
      } else if (curWorkType === WorkType.SmWelding) {
        let weldProcessInput = processInputs?.[j];

        let weldLen = weldProcessInput?.details?.[0].weldingList?.length;
        if (cardDetails?.weldInfo?.length > 0) {
          weldProcessInput?.details?.[0]?.weldingList?.shift();
          for (let k = 0; k < cardDetails?.weldInfo?.length; k++) {
            const weld = cardDetails?.weldInfo?.[k];
            let typeId = weldingTypes?.[0]?.id;
            let weldId = weld?.weldType + 1;
            const result = weldingTypes?.find((weldItem) => {
              return weldItem.id === weldId && weldItem.isUsed;
            });
            if (result) {
              typeId = result?.id;
            }

            const newListRow = {
              id: k + 1 + weldLen,
              yousetsuType: typeId,
              yousetsuTypeAutoExtract: typeId,
              senchou: weld?.length ? toDecimal(weld?.length, 2) : toDecimal(0, 2), //連続/タップ溶接の長さ // IQX_WEBEST-193
              senchouAutoExtract: weld?.length ? toDecimal(weld?.length, 2) : toDecimal(0, 2), //連続/タップ溶接の長さ // IQX_WEBEST-193
              senchouKaisu: weld?.number ? weld?.number : 1, // 連続/タップ回数 // IQX_WEBEST-193
              senchouKaisuAutoExtract: weld?.number ? weld?.number : 1, // 連続/タップ回数 // IQX_WEBEST-193
              senchouYousetsushiage: 0,
              senchouYousetsushiageAutoExtract: 0,
              total1: weld?.length && weld?.number ? toDecimal(weld?.length * weld?.number, 2) : toDecimal(0, 2), // IQX_WEBEST-193

              karitsukeCnt: weld?.tackLocations ? parseInt(weld?.tackLocations) : 0, // 仮付箇所数 // IQX_WEBEST-193
              karitsukeCntAutoExtract: weld?.tackLocations ? parseInt(weld?.tackLocations) : 0, // 仮付箇所数 // IQX_WEBEST-193
              karitsukeKaisu: weld?.tackNumber ? parseInt(weld?.tackNumber) : 1, // 仮付回数 // IQX_WEBEST-193
              karitsukeKaisuAutoExtract: weld?.tackNumber ? parseInt(weld?.tackNumber) : 1, // 仮付回数 // IQX_WEBEST-193
              karitsukeYousetsushiage: 0,
              karitsukeYousetsushiageAutoExtract: 0,
              total2: weld?.tackLocations && weld?.tackNumber ? parseInt(weld?.tackLocations * weld?.tackNumber) : 0, // IQX_WEBEST-193
            };
            weldProcessInput?.details[0]?.weldingList?.push(newListRow);
          }
        } else {
          weldProcessInput.details[0].weldingList[0].yousetsuType = weldingTypes?.[0]?.id;
          weldProcessInput.details[0].weldingList[0].yousetsuTypeAutoExtract = weldingTypes?.[0]?.id;
          weldProcessInput.details[0].weldingList[0].senchou = toDecimal(0, 2);
          weldProcessInput.details[0].weldingList[0].senchouAutoExtract = toDecimal(0, 2);
          weldProcessInput.details[0].weldingList[0].senchouKaisu = 1;
          weldProcessInput.details[0].weldingList[0].senchouKaisuAutoExtract = 1;
          weldProcessInput.details[0].weldingList[0].senchouYousetsushiage = 0;
          weldProcessInput.details[0].weldingList[0].senchouYousetsushiageAutoExtract = 0;
          weldProcessInput.details[0].weldingList[0].total1 = toDecimal(0, 2);

          weldProcessInput.details[0].weldingList[0].karitsukeCnt = 0;
          weldProcessInput.details[0].weldingList[0].karitsukeCntAutoExtract = 0;
          weldProcessInput.details[0].weldingList[0].karitsukeKaisu = 1;
          weldProcessInput.details[0].weldingList[0].karitsukeKaisuAutoExtract = 1;
          weldProcessInput.details[0].weldingList[0].karitsukeYousetsushiage = 0;
          weldProcessInput.details[0].weldingList[0].karitsukeYousetsushiageAutoExtract = 0;
          weldProcessInput.details[0].weldingList[0].total2 = 0;
        }
        // サプ溶接種類
        let subWeldLen = weldProcessInput?.details?.[0]?.subWeldingList?.length;
        if (cardDetails?.subWeldInfo?.length > 0) {
          weldProcessInput?.details?.[0]?.subWeldingList?.shift();
          for (let k = 0; k < cardDetails?.subWeldInfo?.length; k++) {
            const subWeld = cardDetails?.subWeldInfo?.[k];
            let typeId = subWeldingTypes?.[0]?.id;
            let typeGroup = subWeldingTypes?.[0]?.group;
            // ***
            let subWeldType = SubWeldTypes?.filter(
              (itemTyp) => itemTyp.value === cardDetails?.subWeldInfo?.[k]?.name
            )?.[0]?.id;
            let result = subWeldingTypes?.filter((subWeldItem) => subWeldItem.id == subWeldType)?.[0];

            if (result) {
              typeId = result?.id;
              typeGroup = result?.group;
            }

            const newListRow = {
              id: k + 1 + subWeldLen,
              subWeldingType: typeId,
              subWeldingTypeAutoExtract: typeId,
              daimeter: subWeld?.xl ? toDecimal(subWeld?.xl, 2) : toDecimal(0, 2),
              daimeterAutoExtract: subWeld?.xl ? toDecimal(subWeld?.xl, 2) : toDecimal(0, 2),
              number: subWeld?.number ? toDecimal(subWeld?.number, 2) : toDecimal(0, 2),
              numberAutoExtract: subWeld?.number ? toDecimal(subWeld?.number, 2) : toDecimal(0, 2),
              count: 1,
              countAutoExtract: 1,
              yousetsushiage: 0,
              total: subWeld?.xl && subWeld?.number ? toDecimal(subWeld?.xl * subWeld?.number, 2) : toDecimal(0, 2), // IQX_WEBEST-208
              subWeldingGroupType: typeGroup,
              subWeldingGroupTypeAutoExtract: typeGroup,
            };
            weldProcessInput.details[0].subWeldingList.push(newListRow);
          }
        } else {
          weldProcessInput.details[0].subWeldingList[0].subWeldingType = subWeldingTypes?.[0]?.id;
          weldProcessInput.details[0].subWeldingList[0].subWeldingTypeAutoExtract = subWeldingTypes?.[0]?.id;
          (weldProcessInput.details[0].subWeldingList[0].daimeter = toDecimal(0, 2)),
            (weldProcessInput.details[0].subWeldingList[0].daimeterAutoExtract = toDecimal(0, 2)),
            (weldProcessInput.details[0].subWeldingList[0].number = toDecimal(0, 2)),
            (weldProcessInput.details[0].subWeldingList[0].numberAutoExtract = toDecimal(0, 2)),
            (weldProcessInput.details[0].subWeldingList[0].count = 1),
            (weldProcessInput.details[0].subWeldingList[0].countAutoExtract = 1),
            (weldProcessInput.details[0].subWeldingList[0].yousetsushiage = 0),
            (weldProcessInput.details[0].subWeldingList[0].total = toDecimal(0, 2));
          weldProcessInput.details[0].subWeldingList[0].subWeldingGroupType = subWeldingTypes?.[0]?.group;
          weldProcessInput.details[0].subWeldingList[0].subWeldingGroupTypeAutoExtract = subWeldingTypes?.[0]?.group;
        }

        updateProcessInputs.push(weldProcessInput);
      } else if (curWorkType === WorkType.SmSecondaryWork) {
        let secWorkProcessInput = processInputs[j];
        let secWorkLen = secWorkProcessInput?.details?.length;
        if (cardDetails?.burringTappings?.length > 0) {
          secWorkProcessInput?.details?.shift();
          for (let k = 0; k < cardDetails?.burringTappings?.length; k++) {
            const secWork = cardDetails?.burringTappings?.[k];
            let typeId = secWorkTypes?.[0]?.id;
            let typeGroup = secWorkTypes?.[0]?.group;
            // ***
            let secWorkType = SecondaryWorkTypes?.filter(
              (itemType) => itemType.value === cardDetails?.burringTappings?.[k]?.name
            )?.[0]?.id;
            let result = secWorkTypes?.filter((subWeldItem) => subWeldItem.id == secWorkType)?.[0];

            if (result) {
              typeId = result?.id;
              typeGroup = result?.group;
            }

            const newListRow = {
              id: k + 1 + secWorkLen,
              types: typeId,
              typesAutoExtract: typeId,
              diameter: secWork?.size ? toDecimal(secWork?.size, 2) : toDecimal(0, 2),
              diameterAutoExtract: secWork?.size ? toDecimal(secWork?.size, 2) : toDecimal(0, 2),
              xsize: secWork?.cp?.x ? toDecimal(secWork?.cp?.x, 2) : toDecimal(0, 2),
              xsizeAutoExtract: secWork?.cp?.x ? toDecimal(secWork?.cp?.x, 2) : toDecimal(0, 2),
              ysize: secWork?.cp?.y ? toDecimal(secWork?.cp?.y, 2) : toDecimal(0, 2),
              ysizeAutoExtract: secWork?.cp?.y ? toDecimal(secWork?.cp?.y, 2) : toDecimal(0, 2),
              perimeter: toDecimal(0, 2),
              perimeterAutoExtract: toDecimal(0, 2),
              count: secWork?.number ? Number(secWork?.number) : 1, // IQX_WEBEST-209
              countAutoExtract: secWork?.number ? Number(secWork?.number) : 1, // IQX_WEBEST-209
              blankFlag: false,
              blankFlagAutoExtract: false,
              workTypeGroup: typeGroup,
              workTypeGroupAutoExtract: typeGroup,
            };
            secWorkProcessInput.details.push(newListRow);
          }
        } else {
          secWorkProcessInput.details[0].types = secWorkTypes?.[0]?.id;
          secWorkProcessInput.details[0].typesAutoExtract = secWorkTypes?.[0]?.id;
          secWorkProcessInput.details[0].diameter = toDecimal(0, 2);
          secWorkProcessInput.details[0].diameterAutoExtract = toDecimal(0, 2);
          secWorkProcessInput.details[0].xsize = toDecimal(0, 2);
          secWorkProcessInput.details[0].xsizeAutoExtract = toDecimal(0, 2);
          secWorkProcessInput.details[0].ysize = toDecimal(0, 2);
          secWorkProcessInput.details[0].ysizeAutoExtract = toDecimal(0, 2);
          secWorkProcessInput.details[0].perimeter = toDecimal(0, 2);
          secWorkProcessInput.details[0].perimeterAutoExtract = toDecimal(0, 2);
          secWorkProcessInput.details[0].count = 1;
          secWorkProcessInput.details[0].countAutoExtract = 1;
          secWorkProcessInput.details[0].blankFlag = false;
          secWorkProcessInput.details[0].blankFlagAutoExtract = false;
          secWorkProcessInput.details[0].workTypeGroup = secWorkTypes?.[0]?.group;
          secWorkProcessInput.details[0].workTypeGroupAutoExtract = secWorkTypes?.[0]?.group;
        }
        updateProcessInputs.push(secWorkProcessInput);
      } else if (curWorkType === WorkType.SmDeburringAuto) {
        let autoDeburProcessInput = processInputs[j];
        autoDeburProcessInput.details[0].area = cardDetailsArea;
        autoDeburProcessInput.details[0].areaAutoExtract = cardDetailsArea; // IQX_WEBEST-179
        // if (weight) {
        autoDeburProcessInput.details[0].weight = Number.isFinite(weight) ? toDecimal(weight, 2) : toDecimal(0, 2);
        autoDeburProcessInput.details[0].weightAutoExtract = Number.isFinite(weight)
          ? toDecimal(weight, 2)
          : toDecimal(0, 2); // IQX_WEBEST-179
        // }
        autoDeburProcessInput.details[0].countAutoExtract = 1;
        updateProcessInputs.push(autoDeburProcessInput);
      } else if (curWorkType === WorkType.SmDeburringManual) {
        let manualDeburProcessInput = processInputs[j];
        manualDeburProcessInput.details[0].length = cardDetails?.contourLength?.outerLength
          ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
          : toDecimal(0, 2);
        manualDeburProcessInput.details[0].autoExtract = cardDetails?.contourLength?.outerLength
          ? toDecimal(cardDetails?.contourLength?.outerLength, 2)
          : toDecimal(0, 2); // IQX_WEBEST-179
        manualDeburProcessInput.details[0].count = 1;
        manualDeburProcessInput.details[0].countAutoExtract = 1;

        manualDeburProcessInput.details[1].length = cardDetails?.contourLength?.innerLength
          ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
          : toDecimal(0, 2);
        manualDeburProcessInput.details[1].autoExtract = cardDetails?.contourLength?.innerLength
          ? toDecimal(cardDetails?.contourLength?.innerLength, 2)
          : toDecimal(0, 2); // IQX_WEBEST-179
        manualDeburProcessInput.details[1].count = 1;
        manualDeburProcessInput.details[1].countAutoExtract = 1;
        updateProcessInputs.push(manualDeburProcessInput);
      } else if (curWorkType === WorkType.SmSurface) {
        let surfaceProcessInput = processInputs[j];
        if (surfaceProcessInput?.details) {
          surfaceProcessInput.details[0].areaUnitPrice = cardDetailsArea;
          surfaceProcessInput.details[0].areaAutoExtract = cardDetailsArea; // IQX_WEBEST-179
          surfaceProcessInput.details[0].totalArea = cardDetailsArea * 1;
          surfaceProcessInput.details[0].areaCount = 1;
          surfaceProcessInput.details[0].areaCountAutoExtract = 1;
          surfaceProcessInput.details[0].weightUnitPrice = Number.isFinite(weight)
            ? toDecimal(weight, 2)
            : toDecimal(0, 2);
          surfaceProcessInput.details[0].weightAutoExtract = Number.isFinite(weight)
            ? toDecimal(weight, 2)
            : toDecimal(0, 2); // IQX_WEBEST-179
          surfaceProcessInput.details[0].totalWeight = Number.isFinite(weight)
            ? toDecimal(weight, 2) * 1
            : toDecimal(0, 2);
          surfaceProcessInput.details[0].weightCount = 1;
          surfaceProcessInput.details[0].weightCountAutoExtract = 1;
        }
        updateProcessInputs.push(surfaceProcessInput);
      } else if (curWorkType === WorkType.SmShearing) {
        let shearingProcessInput = processInputs[j];
        shearingProcessInput.details[0].numOfCuts = 1;
        shearingProcessInput.details[0].autoExtract = 1; // IQX_WEBEST-179
        updateProcessInputs.push(shearingProcessInput);
      } else if (curWorkType === WorkType.SmInspection) {
        let inspectionProcessInput = processInputs[j];
        inspectionProcessInput.details[0].autoExtract = 1;
        updateProcessInputs.push(inspectionProcessInput);
      }
    }
    //CADからの工程入力情報を対象の板金オブジェクトに更新
    curIq3Info.processInput = updateProcessInputs;

    // 材料詳細パターン情報を準備する
    let materialDetailPatterns = [];

    // 材料詳細サイズリスト情報を準備する
    let materialDetailSizes = [];
    let materialSizeIq3Infos = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.materialSizeIq3;
    if (materialSizeIq3Infos) {
      materialDetailSizes = materialSizeIq3Infos
        ?.filter((item) => item.info.isUsed && item.name !== 'Free')
        ?.map((item, index) => {
          let data = getInitMaterialSizeInfo(index, item);
          materialDetailPatterns = getInitMaterialPatternsInfo(materialDetailPatterns, item);
          return data;
        });
    }
    curIq3Info.materialDetailSizes = materialDetailSizes;
    curIq3Info.materialDetailPatterns = materialDetailPatterns;
    // ブランクの場合
    let blankProcess = getProcessRecord(
      ServiceClass.SheetMetal,
      [WorkType.SmBlankLaser, WorkType.SmBlankPunch, WorkType.SmBlankCombi], // レーザー、パンチ、複合機
      selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.process
    );
    // 板金工程選択にブランクを使用している場合、
    let usedBlankProcess = curIq3Info?.processSelect?.details?.find(
      (selectItem) =>
        selectItem.isUsedForCalc && blankProcess?.findIndex((item) => item.id === selectItem.processId) > -1
    );
    // 使用している装置の情報を取得する
    let usedDeviceInfo = selectedEstimateData?.estimateProducts?.calcParameters?.parameters?.device?.find(
      (device) => device.id === usedBlankProcess?.deviceId
    );
    // 装置がある場合、
    if (usedDeviceInfo) {
      // 装置から材料配置情報
      let materialArrange = usedDeviceInfo?.details?.materialArrange;
      curIq3Info.grabbingX = materialArrange?.graspAllowanceX;
      curIq3Info.grabbingY = materialArrange?.graspAllowanceY;
      curIq3Info.pierWidthX = materialArrange?.xWidth;
      curIq3Info.pierWidthY = materialArrange?.yWidth;
      curIq3Info.worlRangeX = materialArrange?.workRangeX;
      curIq3Info.worlRangeY = materialArrange?.workRangeY;
    }
    setSelectedData(curIq3Info);
    for (let e = 0; e < selectedEstimateData.esIq3Info?.length; e++) {
      if (selectedEstimateData.esIq3Info[e].id == curIq3Info.id) {
        selectedEstimateData.esIq3Info[e] = curIq3Info;
      }
    }
    let iq3List = selectedEstimateData.esIq3Info;
    let totalWeight = iq3List?.reduce((total, item) => {
      return total + Number(item.weight) * Number(item.partCount); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
    }, 0);
    totalWeight = totalWeight ? totalWeight : 0;
    let totalArea = iq3List?.reduce((total, item) => {
      return total + Number(item.totalSurfaceArea) * Number(item.partCount); // IQX_WEBEST-308 親工程 －表面処置、工程入力画面の「面積/重量」の値変更
    }, 0);
    totalArea = totalArea ? totalArea : 0;
    let totalPartCount = iq3List?.reduce((total, item) => {
      return total + Number(item.partCount);
    }, 0);
    let assenbleProcessInput = selectedEstimateData?.estimateProducts?.processInput?.assenbleProcessInputInfo;
    let inspectionProcessInput = selectedEstimateData?.estimateProducts?.processInput?.inspectionProcessInputInfo;
    let packingProcessInput = selectedEstimateData?.estimateProducts?.processInput?.packingProcessInputInfo;
    if (assenbleProcessInput) {
      assenbleProcessInput.smPartsCount = totalPartCount;
      assenbleProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
      selectedEstimateData.estimateProducts.processInput.assenbleProcessInputInfo = assenbleProcessInput;
    }
    if (inspectionProcessInput) {
      inspectionProcessInput.smPartsCount = totalPartCount;
      inspectionProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
      selectedEstimateData.estimateProducts.processInput.inspectionProcessInputInfo = inspectionProcessInput;
    }
    if (packingProcessInput) {
      packingProcessInput.smPartsCount = totalPartCount;
      packingProcessInput.autoExtract = totalPartCount; // IQX_WEBEST-179
      selectedEstimateData.estimateProducts.processInput.packingProcessInputInfo = packingProcessInput;
    }
    selectedEstimateData.estimateProducts.totalWeight = totalWeight;
    selectedEstimateData.estimateProducts.totalWeightSm = totalWeight;
    selectedEstimateData.estimateProducts.totalSurfaceArea = totalArea;
    props.updateIsRecal(true);
    // })
    // .catch((err) => {
    //   console.error('Error fetching PMX file string:', err);
    // });
    setShowSMCadComponent(false);
  };

  // タブ切り替えで、材料詳細の情報を再計算するかどうかのチェック
  const isReCalMaterial = (isChangedProcessSelect = false) => {
    if (isDialogOk || activeTabKey === '6' || props?.isReCal || iq3ActionForCal || props?.isReCalMaterial) {
      if (props?.isReCalMaterial) {
        if (typeof props?.updateIsRecalMaterial === 'function') props?.updateIsRecalMaterial(false);
        return reCalMaterial.allRecordCal;
      }
      let selectedIq3Data = { ...selectedData };
      if (isChangedProcessSelect) {
        selectedIq3Data = props?.selectedEstimateData?.esIq3Info?.find((iq3) => iq3?.no === selectedData?.no);
        setSelectedData(selectedIq3Data);
      }
      if (isDialogOk && activeTabKey !== '6' && !props?.isEstimateOpen) return reCalMaterial.oneRecordCal;
      let oldSelectedEstimateData = iq3MaterialDetailRef?.current?.getSelectedEstimateData();
      if (oldSelectedEstimateData === undefined && !isDialogOk) return reCalMaterial.noCal; // IQX_WEBEST-335 見積りデータ作成中、パラメータ画面と行き来すると選択材料が変わってしまいます。
      if (props?.selectedEstimateData?.estimateProducts?.id === 0 && oldSelectedEstimateData === undefined)
        return reCalMaterial.oneRecordCal;
      if (props?.selectedEstimateData?.estimateProducts?.id !== 0 && oldSelectedEstimateData === undefined)
        return reCalMaterial.noCal;
      let oldSelectedData = oldSelectedEstimateData?.esIq3Info?.find((iq3) => iq3.no === selectedIq3Data?.no);
      if (props?.selectedEstimateData?.estimateProducts?.id === 0 && oldSelectedData === undefined)
        return reCalMaterial.noCal;
      if (props?.selectedEstimateData?.estimateProducts?.id !== 0 && oldSelectedData === undefined)
        return reCalMaterial.noCal;
      let oldEstiamteQuantity = oldSelectedEstimateData?.estimateProducts?.quantity;
      let estiamteQuantity = props?.selectedEstimateData?.estimateProducts?.quantity;
      oldEstiamteQuantity = oldEstiamteQuantity ? oldEstiamteQuantity : 0;
      estiamteQuantity = estiamteQuantity ? estiamteQuantity : 0;
      // IQX_WEBEST-335 見積りデータ作成中、パラメータ画面と行き来すると選択材料が変わってしまいます。
      oldSelectedData.materialSurfaceIq3Id = oldSelectedData?.materialSurfaceIq3Id
        ? oldSelectedData?.materialSurfaceIq3Id
        : 0;
      selectedIq3Data.materialSurfaceIq3Id = selectedIq3Data?.materialSurfaceIq3Id
        ? selectedIq3Data?.materialSurfaceIq3Id
        : 0;
      if (
        oldSelectedData &&
        (Number(oldSelectedData?.partCount) !== Number(selectedIq3Data?.partCount) ||
          Number(oldSelectedData?.materialIq3Id) !== Number(selectedIq3Data?.materialIq3Id) ||
          Number(oldSelectedData?.materialTypeIq3Id) !== Number(selectedIq3Data?.materialTypeIq3Id) ||
          Number(oldSelectedData?.materialSurfaceIq3Id) !== Number(selectedIq3Data?.materialSurfaceIq3Id) ||
          Number(oldSelectedData?.thickness) !== Number(selectedIq3Data?.thickness) ||
          Number(oldSelectedData?.partSizeX) !== Number(selectedIq3Data?.partSizeX) ||
          Number(oldSelectedData?.partSizeY) !== Number(selectedIq3Data?.partSizeY) ||
          Number(oldSelectedData?.grabbingX) !== Number(selectedIq3Data?.grabbingX) ||
          Number(oldSelectedData?.grabbingY) !== Number(selectedIq3Data?.grabbingY) ||
          Number(oldSelectedData?.pierWidthX) !== Number(selectedIq3Data?.pierWidthX) ||
          Number(oldSelectedData?.pierWidthY) !== Number(selectedIq3Data?.pierWidthY) ||
          Number(oldSelectedData?.worlRangeX) !== Number(selectedIq3Data?.worlRangeX) ||
          Number(oldSelectedData?.worlRangeY) !== Number(selectedIq3Data?.worlRangeY))
      ) {
        return reCalMaterial.oneRecordCal; // 選択中の板金子部品のみ材料を再計算
      } else if (
        Number(estiamteQuantity) !== Number(oldEstiamteQuantity) || // 数量を変更した場合、
        props?.isReCalMaterial || // 再計算の場合、
        (iq3PMXDatas?.length === 0 && props?.isPMXEvent) // PMXデータの取り込み完了した場合、
      ) {
        if (props?.isReCalMaterial) {
          props?.updateIsRecalMaterial(false);
        }
        return reCalMaterial.allRecordCal; // 板金子部品全部の材料を再計算
      }
      return reCalMaterial.noCal; // 計算しない
    }
  };

  // Waitingダイアログを表示・非表示に更新する
  const updateLoading = (load) => {
    setIq3Loading(load);
  };

  const updateIq3ActionForCal = (flg) => {
    setIq3ActionForCal(flg);
  };

  return (
    <>
      <Spin
        spinning={isDialogOk || reCalByAddDelete || iq3ActionForCal || props?.activePartMenu !== '2' ? true : false}
        tip=""
        size="large"
      >
        {/* {props?.activePartMenu === '2' ? ( //見積保存の時、板金の基本情報をRefをアクセスできないため、この条件を解除して子JSごとに条件をいれる。 */}
        <>
          <Form>
            {/* 一覧とプロパティ表示 */}{' '}
            <div
              style={{
                height: '90.8vh',
                marginLeft: '6px',
                marginRight: '6px',
              }}
            >
              <Row id="iq3-rows" style={{ width: '99.5%' }}>
                <Col span={24}>{childPartListHeader}</Col>
              </Row>
              {menuIconList}
              <div id="iq3-list-div" className="iq3-list-div">
                <Table
                  id="iq3EstimateTbl"
                  showSorterTooltip={false}
                  rowClassName={(record) => (record.no == currentRecordNo ? 'active-row' : 'data-row')}
                  columns={iq3Columns}
                  rowKey={(record) => record.no}
                  dataSource={iQ3DataLst}
                  className="iq3-list-tb"
                  pagination={false}
                  // scroll={{ y: 717, x: '10vw' }}
                  //
                  scroll={{ y: 'calc(100vh - 35vh)', x: 'max-content' }}
                  onRow={(record, index) => {
                    return {
                      onClick: (event) => {
                        onRowSelect(record);
                      },
                    };
                  }}
                />
              </div>
              {/* ダイアログOKで再計算するための設置、条件付けで実行 */}
              <div style={{ display: 'none' }} className="iq3-tab-div">
                {/* 基本情報 */}
                <IQ3EstimateDetail
                  selectedIQ3DataDetail={selectedData}
                  ref={iq3DetailRef}
                  materialLst={estimateParameters?.materialIq3}
                  materialTypeLst={estimateParameters?.materialTypeIq3}
                  materialSurfaceLst={estimateParameters?.materialSurfaceIq3}
                  isReCal={props?.isReCal}
                  selectedEstimateData={props.selectedEstimateData}
                  currentRecordNo={currentRecordNo}
                  activeTabKey={activeTabKey}
                  partMenuChange={props.activePartMenu}
                />
                {/* 工程入力 */}
                <IQ3KouteiInput
                  ref={iq3KouteiInputRef}
                  processMasterData={processMasterInfo}
                  selectedIQ3DataDetail={selectedData}
                  materialList={materialLst}
                  currentRecordNo={currentRecordNo}
                  activeTabKey={activeTabKey}
                  selectedEstimateData={props.selectedEstimateData}
                  isReCal={props?.isReCal}
                  dialogOk={isDialogOk}
                />
                {/* 工程積算 */}
                <IQ3KouteiCalculate
                  ref={iq3KouteiCalRef}
                  editMode={editMode}
                  selectedIQ3DataDetail={selectedData}
                  deviceMasterInfo={deviceMasterInfo}
                  processMasterData={processMasterInfo}
                  selectedEstimateData={props.selectedEstimateData}
                  activeTabKey={activeTabKey}
                  currentRecordNo={currentRecordNo}
                  iq3ActionForCal={iq3ActionForCal}
                  isReCal={props?.isReCal}
                  activePartMenu={props?.activePartMenu}
                  selectedProcessSelect={selectedProcessSelect}
                  dialogOk={isDialogOk}
                  currentRecordNoPMX={currentRecordNoPMX}
                  settingInfo={props?.settingInfo}
                />
                {/* 購入品 */}
                <IQ3Purchase
                  ref={purchaseRef}
                  selectedIQ3DataDetail={selectedData}
                  selectedEstimateData={props.selectedEstimateData}
                  getParentQuantity={props?.getParentQuantity}
                  // editMode={editMode}
                  isChildPart={true}
                  activeTabKey={activeTabKey}
                  currentRecordNo={currentRecordNo}
                  isReCal={props?.isReCal}
                  dialogOk={isDialogOk}
                />
                {/* 材料詳細 */}
                <IQ3MaterialDetail
                  ref={iq3MaterialDetailRef}
                  editMode={editMode}
                  selectedIQ3DataDetail={selectedData}
                  selectedEstimateData={props.selectedEstimateData}
                  getParentQuantity={props?.getParentQuantity}
                  materialLst={estimateParameters?.materialIq3}
                  materialTypeLst={estimateParameters?.materialTypeIq3}
                  materialSurfaceLst={estimateParameters?.materialSurfaceIq3}
                  processMasterData={getProcessMstInfo(estimateParameters?.process)}
                  deviceMasterData={getDeviceMstInfo(estimateParameters?.device, estimateParameters?.process)}
                  isReCalMaterial={isReCalMaterial()}
                  activeTabKey={activeTabKey}
                  // 新規子部品+材料詳細のタグ押下+初回押下
                  isFirstTimeMaterialDetail={
                    selectedData && selectedData?.id === 0 && activeTabKey === '6' && isFirstTimeMaterialDetail
                      ? true
                      : false
                  }
                  updateFirstTimeMaterialDetail={updateFirstTimeMaterialDetail}
                  currentRecordNo={currentRecordNo}
                  updateCurIQ3MaterialDetailData={updateCurIQ3MaterialDetailData}
                  loading={props?.loading}
                  dialogOk={isDialogOk}
                  isReCal={props?.isReCal}
                  iq3ActionForCal={iq3ActionForCal}
                />
              </div>
              {/* 工程別合計 */}
              <div
                style={{
                  display: 'flex',
                  marginTop: '0px',
                  position: 'absolute',
                  top: '-36px',
                  right: 0,
                }}
              >
                <KouteiSuryouBetsuBtn
                  selectedEstimateData={props?.selectedEstimateData}
                  getParentQuantity={props?.getParentQuantity}
                  hyoumenProcess={props?.hyoumenProcess}
                />
              </div>
            </div>
          </Form>
          {/** 開発中ポップアップ */}
          {openCommonTaiochuPopup ? commonTaiochuModal(openCommonTaiochuPopup, closeCommonTaiochuPopup) : ''}
          {/** 編集中破棄確認ポップアップ */}
          {editModeCancelConfirm
            ? commonModal(
                editModeCancelConfirm,
                confirmScreenChangeTitle,
                commonFooter(discardConfirmOk, discardConfirmCancel),
                null,
                400,
                discardConfirmOk,
                discardConfirmCancel,
                confirmScreenChangeContent,
                null,
                null,
                false
              )
            : ''}
          {/** 更新 / 破棄の確認メッセージ */}
          {confirmMsgOpen
            ? commonModal(
                confirmMsgOpen,
                modalTitle,
                commonFooter(confirmOk, confirmCancel),
                null,
                400,
                confirmOk,
                confirmCancel,
                discardMode ? confirmDiscardContent : confirmUpdateContent,
                null,
                null,
                false
              )
            : ''}

          {/* 削除 */}
          {isDelete
            ? commonResponsiveConfirmModal(
                isDelete,
                confirmModalTitle,
                commonDeleteFooter(deleteOk, deleteCancel),
                null,
                400,
                deleteOk,
                deleteCancel,
                /*  editMode ? confirmDiscardAndDeleteContent : confirmDeleteContent, */
                <p style={{ fontSize: '13.5px' }}>
                  選択中の子部品を削除します。
                  <br></br>削除したデータは戻せませんが、よろしいですか？
                </p>,
                null,
                null,
                false
              )
            : ''}

          {/* 親部品リストダイアログ */}
          {parentListDisplay ? (
            <Modal
              maskClosable={false}
              open={parentListDisplay}
              title={parentListModalTitle}
              footer={null}
              bodyStyle={{ height: '71.7vh', marginTop: -5, marginLeft: -23 }}
              width={1670}
              onOk={addPartFromParentInfoOk}
              onCancel={addPartFromParentInfoCancel}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              className={null}
              style={{ top: 190, left: 50 }}
              centered={false}
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
            >
              <Spin spinning={iq3Loading} tip="Loading..." size="large">
                <div style={{ borderBottom: '1px solid #6c757d', width: '101.2%' }}>
                  <ParentList
                    getSelectedEstimateData={getSelectedEstimateData}
                    editMode={false}
                    parentListClick={false}
                    isFromiQ3={true}
                    orderOptions={newParameters?.estimateStatus}
                    companyInfo={newParameters?.company}
                    clientInfo={newParameters?.client}
                    userInfo={newParameters?.currentUserInfo}
                    staffInfo={newParameters?.staff}
                    processInfo={newParameters?.process}
                    iq3Loading={updateLoading}
                    onSelectedRowsChange={(rows) => setSelectedRowsFromChild(rows)}
                  />
                </div>
                <Row
                  justify="end"
                  style={{
                    marginBottom: 0,
                    marginTop: 7,
                  }}
                >
                  {/* 2025-09-16 IQX_WEBEST-418 複数子部品の呼び出しは行えないか？ */}
                  <Button
                    className="mainButton"
                    onClick={() => addPartFromParentInfoOk(selectedRowsFromChild)}
                    style={{ marginRight: 5 }}
                  >
                    追加
                  </Button>
                  <Button className="cancelButton" onClick={addPartFromParentInfoCancel}>
                    閉じる
                  </Button>
                </Row>
              </Spin>
            </Modal>
          ) : (
            ''
          )}
          {/* 設定操作 */}
          {isSetting
            ? commonModal(
                isSetting,
                settingModalTitle,
                null,
                { height: 123 },
                450,
                settingOK,
                settingCancel,
                settingContent,
                'updateModalStyle',
                null,
                false
              )
            : ''}

          {/* 基本情報ダイアログ */}
          {activeTabKey === '1' ? (
            <Modal
              maskClosable={false}
              open={activeTabKey === '1' ? true : false}
              title={detailModalTitle}
              footer={null}
              bodyStyle={{ height: '58vh', marginLeft: -17 }}
              width={1290}
              onOk={detailDialogOk}
              onCancel={detailDialogCancel}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              className={null}
              style={{ top: 230, left: 200 }}
              centered={false}
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
            >
              <div className="iq3-tab-div">
                <IQ3EstimateDetail
                  selectedIQ3DataDetail={selectedData}
                  ref={iq3DetailRef}
                  materialLst={estimateParameters?.materialIq3}
                  materialTypeLst={estimateParameters?.materialTypeIq3}
                  materialSurfaceLst={estimateParameters?.materialSurfaceIq3}
                  isReCal={props?.isReCal}
                  selectedEstimateData={props.selectedEstimateData}
                  currentRecordNo={currentRecordNo}
                  activeTabKey={activeTabKey}
                  partMenuChange={props.activePartMenu}
                  tabOpen={activeTabKey === '1' ? true : false}
                />
              </div>
              <Row
                justify="end"
                style={{
                  marginBottom: 0,
                  marginTop: 0,
                }}
              >
                <Button className="mainButton" onClick={detailDialogOk} style={{ marginRight: 5 }}>
                  OK
                </Button>
                <Button className="cancelButton" onClick={detailDialogCancel}>
                  キャンセル
                </Button>
              </Row>
            </Modal>
          ) : (
            ''
          )}
          {/* 工程選択ダイアログ */}
          {activeTabKey === '2' ? (
            <Modal
              maskClosable={false}
              open={activeTabKey === '2' ? true : false}
              title={detailModalTitle}
              footer={null}
              bodyStyle={{ height: '73vh', marginLeft: -17 }}
              width={1200}
              onOk={detailDialogOk}
              onCancel={detailDialogCancel}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              className={null}
              style={{ top: 85, left: 150 }}
              centered={true}
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
            >
              <div className="iq3-tab-div" style={{ height: '70vh', overflowY: 'auto' }}>
                <IQ3KouteiSentaku
                  type={'list'}
                  ref={iq3KouteiSentakuRef}
                  editMode={editMode}
                  selectedIQ3DataDetail={selectedData}
                  // selectedEstimateData={props.selectedEstimateData}
                  selectedDataDetail={props.selectedEstimateData}
                  iQ3DataLst={iQ3DataLst}
                  pmxMode={false}
                  updateSelectedData={updateSelectedData}
                  processMasterData={processMasterInfo}
                  deviceMasterData={deviceMasterInfo}
                  clientMasterData={clientMasterInfo}
                  currentRecordNo={currentRecordNo}
                  activeTabKey={activeTabKey}
                  isReCal={props?.isReCal}
                  updateProcessSelectOfSelectedData={updateProcessSelectOfSelectedData}
                  tabOpen={activeTabKey === '2' ? true : false}
                />
              </div>
              <Row
                justify="end"
                style={{
                  marginBottom: 0,
                  marginTop: 5,
                }}
              >
                <Button className="mainButton" onClick={detailDialogOk} style={{ marginRight: 5 }}>
                  OK
                </Button>
                <Button className="cancelButton" onClick={detailDialogCancel}>
                  キャンセル
                </Button>
              </Row>
            </Modal>
          ) : (
            ''
          )}
          {/* 工程入力ダイアログ */}
          {activeTabKey === '3' ? (
            <Modal
              maskClosable={false}
              open={activeTabKey === '3' ? true : false}
              title={detailModalTitle}
              footer={null}
              bodyStyle={{ height: '73vh', marginLeft: -17 }}
              width={1390}
              onOk={detailDialogOk}
              onCancel={detailDialogCancel}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              className={null}
              style={{ top: 85, left: 215 }}
              centered={true}
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
            >
              <div className="iq3-tab-div" style={{ height: '70vh', overflowY: 'auto' }}>
                <IQ3KouteiInput
                  ref={iq3KouteiInputRef}
                  processMasterData={processMasterInfo}
                  // editMode={editMode}
                  selectedIQ3DataDetail={selectedData}
                  materialList={materialLst}
                  currentRecordNo={currentRecordNo}
                  activeTabKey={activeTabKey}
                  selectedEstimateData={props.selectedEstimateData}
                  isReCal={props?.isReCal}
                  tabOpen={activeTabKey === '3' ? true : false}
                  // 2025-05-27 工程入力で何かしら数値や項目を変更した後、部品リストに変更したことがわかるように表示がほしい。
                  onDataChange={(changed) => setHasProcessInputChanged(changed)}
                />
              </div>
              <Row
                justify="end"
                style={{
                  marginBottom: 0,
                  marginTop: 5,
                }}
              >
                <Button className="mainButton" onClick={detailDialogOk} style={{ marginRight: 5 }}>
                  OK
                </Button>
                <Button className="cancelButton" onClick={detailDialogCancel}>
                  キャンセル
                </Button>
              </Row>
            </Modal>
          ) : (
            ''
          )}
          {/* 工程積算ダイアログ */}
          {activeTabKey === '4' ? (
            <Modal
              maskClosable={false}
              open={activeTabKey === '4' ? true : false}
              title={detailModalTitle}
              footer={null}
              bodyStyle={{ height: '73vh', marginLeft: -17 }}
              width={1370}
              onOk={detailDialogOk}
              onCancel={detailDialogCancel}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              className={null}
              style={{ top: 85, left: 215 }}
              centered={true}
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
            >
              <div className="iq3-tab-div" style={{ height: '70vh', overflowY: 'auto' }}>
                <IQ3KouteiCalculate
                  ref={iq3KouteiCalRef}
                  editMode={editMode}
                  selectedIQ3DataDetail={selectedData}
                  deviceMasterInfo={deviceMasterInfo}
                  processMasterData={processMasterInfo}
                  selectedEstimateData={props.selectedEstimateData}
                  activeTabKey={activeTabKey}
                  currentRecordNo={currentRecordNo}
                  iq3ActionForCal={iq3ActionForCal}
                  isReCal={props?.isReCal}
                  activePartMenu={props?.activePartMenu}
                  selectedProcessSelect={selectedProcessSelect}
                  tabOpen={activeTabKey === '4' ? true : false}
                  settingInfo={props?.settingInfo}
                />
              </div>
              <Row
                justify="end"
                style={{
                  marginBottom: 0,
                  marginTop: 5,
                }}
              >
                <Button className="mainButton" onClick={detailDialogOk} style={{ marginRight: 5 }}>
                  OK
                </Button>
                <Button className="cancelButton" onClick={detailDialogCancel}>
                  キャンセル
                </Button>
              </Row>
            </Modal>
          ) : (
            ''
          )}
          {/* 購入品ダイアログ */}
          {activeTabKey === '5' ? (
            <Modal
              maskClosable={false}
              open={activeTabKey === '5' ? true : false}
              title={detailModalTitle}
              footer={null}
              bodyStyle={{ height: '73vh', marginLeft: -17 }}
              width={1300}
              onOk={detailDialogOk}
              onCancel={detailDialogCancel}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              className={null}
              style={{ top: 85, left: 205 }}
              centered={true}
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
            >
              <div className="iq3-tab-div" style={{ height: '70vh', overflowY: 'auto' }}>
                <IQ3Purchase
                  ref={purchaseRef}
                  selectedIQ3DataDetail={selectedData}
                  selectedEstimateData={props.selectedEstimateData}
                  getParentQuantity={props?.getParentQuantity}
                  // editMode={editMode}
                  isChildPart={true}
                  activeTabKey={activeTabKey}
                  currentRecordNo={currentRecordNo}
                  isReCal={props?.isReCal}
                  tabOpen={activeTabKey === '5' ? true : false}
                />
              </div>
              <Row
                justify="end"
                style={{
                  marginBottom: 0,
                  marginTop: 5,
                }}
              >
                <Button className="mainButton" onClick={detailDialogOk} style={{ marginRight: 5 }}>
                  OK
                </Button>
                <Button className="cancelButton" onClick={detailDialogCancel}>
                  キャンセル
                </Button>
              </Row>
            </Modal>
          ) : (
            ''
          )}
          {/* 材料詳細ダイアログ */}
          {activeTabKey === '6' ? (
            <Modal
              maskClosable={false}
              open={activeTabKey === '6' ? true : false}
              title={detailModalTitle}
              footer={null}
              bodyStyle={{ height: '73vh', marginLeft: -17 }}
              width={1300}
              onOk={detailDialogOk}
              onCancel={detailDialogCancel}
              closeIcon={<CloseOutlined style={{ color: 'white' }} />}
              className={null}
              style={{ top: 85, left: 205 }}
              centered={true}
              modalRender={(modal) => (
                <Draggable handle=".ant-modal-header">
                  <div>{modal}</div>
                </Draggable>
              )}
            >
              <Spin spinning={isDialogOk} tip="Loading..." size="large">
                <div className="iq3-tab-div" style={{ height: '70vh', overflowY: 'auto' }}>
                  <IQ3MaterialDetail
                    ref={iq3MaterialDetailRef}
                    editMode={editMode}
                    selectedIQ3DataDetail={selectedData}
                    selectedEstimateData={props.selectedEstimateData}
                    getParentQuantity={props?.getParentQuantity}
                    materialLst={estimateParameters?.materialIq3}
                    materialTypeLst={estimateParameters?.materialTypeIq3}
                    materialSurfaceLst={estimateParameters?.materialSurfaceIq3}
                    processMasterData={getProcessMstInfo(estimateParameters?.process)}
                    deviceMasterData={getDeviceMstInfo(estimateParameters?.device, estimateParameters?.process)}
                    isReCalMaterial={isReCalMaterial()}
                    activeTabKey={activeTabKey}
                    // 新規子部品+材料詳細のタグ押下+初回押下
                    isFirstTimeMaterialDetail={
                      selectedData && selectedData?.id === 0 && activeTabKey === '6' && isFirstTimeMaterialDetail
                        ? true
                        : false
                    }
                    updateFirstTimeMaterialDetail={updateFirstTimeMaterialDetail}
                    currentRecordNo={currentRecordNo}
                    updateCurIQ3MaterialDetailData={updateCurIQ3MaterialDetailData}
                    loading={props?.loading}
                    tabOpen={activeTabKey === '6' ? true : false}
                    iq3ActionForCal={iq3ActionForCal}
                  />
                </div>
                <Row
                  justify="end"
                  style={{
                    marginBottom: 0,
                    marginTop: 5,
                  }}
                >
                  <Button className="mainButton" onClick={detailDialogOk} style={{ marginRight: 5 }}>
                    OK
                  </Button>
                  <Button className="cancelButton" onClick={detailDialogCancel}>
                    キャンセル
                  </Button>
                </Row>
              </Spin>
            </Modal>
          ) : (
            ''
          )}

          {/* 計算式ダイアログ */}
          {activeTabKey === '7' && (
            <EstimateFormulaModal
              isIQ3={true}
              detailModalTitle={detailModalTitle}
              detailDialogOk={detailDialogOk}
              detailDialogCancel={detailDialogCancel}
              estimateData={props.selectedEstimateData}
              processMasterInfo={processMasterInfo}
              settingInfo={props?.settingInfo}
            />
          )}

          {/** 2025-07-22 IQX_WEBEST-443 機能追加の要望⑤「複数子部品追加登録」 */}
          {visibleRecordNum
            ? commonResponsiveConfirmModal(
                visibleRecordNum,
                requestRecordNumModalTitle,
                commonFooter(requestOk, requestCancel),
                null,
                400,
                requestOk,
                requestCancel,
                requestRecordNumContent,
                null,
                null,
                false
              )
            : ''}

          {/* すべてチェックなしのメッセージ表示 */}
          {confirmCalCadSim
            ? commonModal(
                confirmCalCadSim,
                confirmModalTitle,
                commonFooter(calSimCAD, calSimCancel),
                null,
                370,
                calSimCAD,
                calSimCancel,
                curPMXInfo === '' ? confirmPMXSaveContent : confirmCalSimCadContent,
                null,
                null,
                true
              )
            : ''}

          {/** SM　CAD表示 */}
          {showSMCadComponent && (
            <CommonResponsiveModal
              isOpen={showSMCadComponent}
              title={''}
              footer={[
                <Button key="close" className="mainButton" onClick={calSimCADPMXData}>
                  閉じる
                </Button>,
                <Button key="cancel" className="cancelButton" onClick={onCancel}>
                  Cancel
                </Button>,
              ]}
              width={1700}
              onOk={null}
              onCancel={onCancel}
              content={
                <div style={{ width: '100%', height: '80vh', border: 'none' }}>
                  <iframe srcDoc={iframeHtml} style={{ width: '100%', height: '80vh', border: 'none' }} />
                </div>
              }
              className={null}
            />
          )}
        </>
        {/* ) : (
          ''
        )} */}
      </Spin>
    </>
  );
});

export default IQ3Estimate;
